import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormRedemption } from "./c005-bookingform-redemption";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { bookingFormSideTrip } from "./c005-bookingform-sidetrip";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import { wcagOptions } from "./wcag";
import 'MagnificPopup';

export class mobileBookingFormContent {
	private bookingFormSubmit = new bookingFormSubmit();
	private wcag = new wcagOptions();
	private bcommon = new bookingFormCommon();

    $scopeipad:any = $('#book-flight--container');
	$siteCode: string = '';
	$officeCode: string = '';
	$error:Array<string> = [];

	$instance:any;

	$scopeMob: any = $('#mobile-bookflight--container'); // mobile ibe
	// for recent search clicked state to prevent auto focus to the next field with ibe search
	recentSearchActive:boolean = false;
	// value for populating to to location field on from location update complete
	toPrepop:string = null;
	isIbePrepop:boolean = false;
	isUkCitySelectedForIbeSearch: boolean = false;
	xDown:any=null;                                      
	yDown:any=null;

	enrichAlwaysON: string = $('[data-is-always-on-discount]').attr('data-is-always-on-discount');
	isValidFromLocation: boolean = false;
	isValidToLocation: boolean =false;
	isInAllowedListEnrichOnFrom: boolean = false;
	enrichAlwaysOnCountriesData: any = $('[data-enrich-alwaysOn-countries-Data]').attr('data-enrich-alwaysOn-countries-Data');
	isEligibleEnrichAlwaysOn: boolean=false;
	availableDatesForTravelPassReturn: any= [];
	availableDatesForTravelPassDept: any= [];
	/**
	 * @function bookingNav
	 * !!! Global
	 */
	nav(): void {
		let _self = this;
		let $ibeNav:any;
		if($('.ibe-refresh').length >0) {
			$ibeNav     = $('.desktop #bookingNav');
		}
		else {
			$ibeNav     = $('#bookingNav');
		}
		let bcommon = _self.bcommon;
		let $deviceHeight = $(window).height()/1.78;

		let $checkInMob: any      = $('#mob-checkin--container');
		let $viewBookingMob: any  = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $loginMob: any        = $('#mob-login--container');
		let $loggedinMob: any     = $('#mob-logged-in-user-menu');
		let $mhStayMob: any       = $('#mob-stay--container');
		let $mhUpgradeMob: any    = $('#mob-mhupgrade--container');
		let $mholidayWrapper:any  = $('#mobile-mholidays--container');
		let $flightUpgradMob: any    = $('#mob-flightupgrade--container');
		let $moreLinksMob: any 	 = $('#mob-more-links--container');
		let $enrichHotelsMob: any 	 = $('#mobile-enrichhotels--container');

		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any  = $('#mab-bookingnav.mobile #bookingNav');

		let $errorValidationGen:any     = $('.error-validation');
		let $bookingFormTitle:any       = $('.booking-form--title');
		let $dateFormTitle:any          = $('.date-form--title');
		let $bookdateSelectorGen:any    = $('.book-date--selector');
		let $selectizeInputGen:any      = $('.ibe-form--container .selectize-control .selectize-input');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');

		let $navOverlay: any = $('.mab-nav--overlay');
		let $enrichMobBookFLight: any = $('.enrich-revamp .mob-book-flight');
		let $enrichMobSearchFLight: any = $('.enrich-revamp .link-search-flight');
		let $enrichMobRedeemFLight: any = $('.enrich-revamp .mob-redeem-flights');
		let $paymentMethodOptions :any = $(".payment-method-options");
		let $mobFlysiswa: any = $mobIbeNav.find('.mob-flysiswa');
		// array of both mobile ibe links (top nav & side nav)
		let mobileIbeLinks = [
			$mobIbeNav.find('.mobile-book-flight'),
			$navOverlay.find('.mobile-book-flight'),
			$enrichMobBookFLight,
			$enrichMobSearchFLight,
			$enrichMobRedeemFLight,
		];

		// IBE Navigation show/hide Mobile Check in container
		mobileIbeLinks.map(function ($el: any, i: number) {
			$el.click(function () {
				adobeDataLayer.push('click', {
					'clickName': 'click:tab-click:top-nav-flight',
					'componentType': 'tab',
					'componentName': 'Flight Top Menu',
					'componentID': '',
					'attributes': []
				});
				let $fromLocationMobile: any = $('#fromLocationMobile').parent().find('.selectize-control .selectize-input');
				let $toLocationMobile: any = $('#toLocationMobile').parent().find('.selectize-control .selectize-input');

				$ibeNavList.removeClass('selected');
				$ibeNavList.find('a.mobile-book-flight').parent().addClass('selected');
				$('.mob-flysiswa-voucher-info').addClass('hide');
				_self.$scopeMob.find('.trip-type--container .returnTrip').addClass('selected');
				_self.$scopeMob.show();
				_self.$scopeMob.find('.trip-type--container .returnTrip').trigger('click');

				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$enrichHotelsMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$mholidayWrapper.hide();
				$flightUpgradMob.hide();
				$moreLinksMob.hide();

				// form stuff
				$errorValidationGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$dateFormTitle.removeClass('has-error');
				$bookdateSelectorGen.removeClass('has-error');
				$selectizeInputGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$fromLocationMobile.removeClass('has-error');
				$toLocationMobile.removeClass('has-error');

				bcommon.scrollToTopIBE();


				if (window.innerWidth > 767 && window.innerWidth < 1200) {

					let $fromLocation: any = _self.$scopeipad.find('.ibe-from--location');
					let $fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input');
					let $toLocation: any = _self.$scopeipad.find('.ibe-to--location');
					let $toSelectize: any = $toLocation.parent().find('.selectize-control .selectize-input');
					let $mcityToSelectInput: any = $('.multi-cityTrip--Container').find('select.mc-to--location');
					let $checkIn: any = $('#check-in--container');
					let $viewBooking: any = $('#view-booking--container');
					let $flightStatus: any = $('#flight-status--container');
					let $login: any = $('#login-container');
					let $mholidays: any = $('#mholiday-ibe--container');
					let $flightHotelBtn: any = $('.flights-hotel-btn');
					let $loggedin: any = $('#logged-in-user-menu');
					let $mhStay: any = $('#ibe-stay--container');
					let $mhUpgrade: any = $('#mhupgrade-in--container');
					$flightHotelBtn.attr('style', 'display:none !important;');
					$ibeNavList.find('a.book-flight').parent().addClass('selected');
					$ibeNav.find('.book-flight').parent().addClass('selected');

					// desktop stuff
					_self.$scopeipad.show();
					$checkIn.hide();
					$viewBooking.hide();
					$flightStatus.hide();
					$login.hide();
					$mholidays.hide();
					$loggedin.addClass('hidden');

					// mobile stuff
					_self.$scopeMob.hide();
					$checkInMob.hide();
					$viewBookingMob.hide();
					$flightStatusMob.hide();
					$loginMob.hide();
					$loggedinMob.hide();
					$mhStay.hide();
					$mhUpgrade.hide();

					// form stuff
					$errorValidationGen.hide();
					$bookingFormTitle.removeClass('has-error');
					$dateFormTitle.removeClass('has-error');
					$bookdateSelectorGen.removeClass('has-error');
					$fromSelectize.removeClass('has-error');
					$toSelectize.removeClass('has-error');
					$mcityToSelectInput.removeClass('has-error');
					$couponCodeGen.removeClass('has-error');
					$redemptionLogin.removeClass('has-error');

				}
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .enrich-header').addClass('hide');
					$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');
					_self.expandIbe(_self.$scopeMob);
					let targetHeight: any = $(window).innerHeight() + 'px';
					$('.enrich-revamp #mobile-bookflight--container').css('height', targetHeight);	
					if($(event.currentTarget).hasClass('mob-redeem-flights')) {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', false);										
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).trigger('click');						
					}
					else {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);						
					}					
				}
			});
		});
		// apply same for flysiswa tab 
		$mobFlysiswa.click (function () {
			adobeDataLayer.push('click', {
					'clickName': 'click:tab-click:top-nav-flysiswa',
					'componentType': 'tab',
					'componentName': 'Flight Top Menu',
					'componentID': '',
					'attributes': []
				});
				let $fromLocationMobile: any = $('#fromLocationMobile').parent().find('.selectize-control .selectize-input');
				let $toLocationMobile: any = $('#toLocationMobile').parent().find('.selectize-control .selectize-input');

				$ibeNavList.removeClass('selected');
				$ibeNavList.find('a.mob-flysiswa').parent().addClass('selected');
				$('.mob-flysiswa-voucher-info').removeClass('hide');
				_self.$scopeMob.find('.trip-type--container .returnTrip').addClass('selected');
				_self.$scopeMob.show();
				_self.$scopeMob.find('.trip-type--container .returnTrip').trigger('click');

				$checkInMob.hide();
				$viewBookingMob.hide();
				$flightStatusMob.hide();
				$mhStayMob.hide();
				$enrichHotelsMob.hide();
				$mhUpgradeMob.hide();
				$loginMob.hide();
				$loggedinMob.hide();
				$mholidayWrapper.hide();
				$flightUpgradMob.hide();
				$moreLinksMob.hide();

				// form stuff
				$errorValidationGen.hide();
				$bookingFormTitle.removeClass('has-error');
				$dateFormTitle.removeClass('has-error');
				$bookdateSelectorGen.removeClass('has-error');
				$selectizeInputGen.removeClass('has-error');
				$couponCodeGen.removeClass('has-error');
				$redemptionLogin.removeClass('has-error');
				$fromLocationMobile.removeClass('has-error');
				$toLocationMobile.removeClass('has-error');

				bcommon.scrollToTopIBE();


				if (window.innerWidth > 767 && window.innerWidth < 1200) {

					let $fromLocation: any = _self.$scopeipad.find('.ibe-from--location');
					let $fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input');
					let $toLocation: any = _self.$scopeipad.find('.ibe-to--location');
					let $toSelectize: any = $toLocation.parent().find('.selectize-control .selectize-input');
					let $mcityToSelectInput: any = $('.multi-cityTrip--Container').find('select.mc-to--location');
					let $checkIn: any = $('#check-in--container');
					let $viewBooking: any = $('#view-booking--container');
					let $flightStatus: any = $('#flight-status--container');
					let $login: any = $('#login-container');
					let $mholidays: any = $('#mholiday-ibe--container');
					let $flightHotelBtn: any = $('.flights-hotel-btn');
					let $loggedin: any = $('#logged-in-user-menu');
					let $mhStay: any = $('#ibe-stay--container');
					let $mhUpgrade: any = $('#mhupgrade-in--container');
					$flightHotelBtn.attr('style', 'display:none !important;');
					$ibeNavList.find('a.book-flight').parent().addClass('selected');
					$ibeNav.find('.book-flight').parent().addClass('selected');

					// desktop stuff
					_self.$scopeipad.show();
					$checkIn.hide();
					$viewBooking.hide();
					$flightStatus.hide();
					$login.hide();
					$mholidays.hide();
					$loggedin.addClass('hidden');

					// mobile stuff
					_self.$scopeMob.hide();
					$checkInMob.hide();
					$viewBookingMob.hide();
					$flightStatusMob.hide();
					$loginMob.hide();
					$loggedinMob.hide();
					$mhStay.hide();
					$mhUpgrade.hide();

					// form stuff
					$errorValidationGen.hide();
					$bookingFormTitle.removeClass('has-error');
					$dateFormTitle.removeClass('has-error');
					$bookdateSelectorGen.removeClass('has-error');
					$fromSelectize.removeClass('has-error');
					$toSelectize.removeClass('has-error');
					$mcityToSelectInput.removeClass('has-error');
					$couponCodeGen.removeClass('has-error');
					$redemptionLogin.removeClass('has-error');

				}
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .enrich-header').addClass('hide');
					$('.enrich-revamp .enrich-mobile-ibe-container').removeClass('hide');
					_self.expandIbe(_self.$scopeMob);
					let targetHeight: any = $(window).innerHeight() + 'px';
					$('.enrich-revamp #mobile-bookflight--container').css('height', targetHeight);	
					if($(event.currentTarget).hasClass('mob-redeem-flights')) {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', false);										
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).trigger('click');						
					}
					else {
						_self.$scopeMob.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
						_self.$scopeMob.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);						
					}					
				}
				// Update OND
				const path = window.location.pathname;
				const flysiswaValue = $('#onlyShowFlysiswa').val();
				if (path.indexOf('student-portal') > 0 && flysiswaValue == 'true') {
					$('#navbarNav .mobile-book-flight').parent().css('display', 'none');
					$('#navbarNav .mobile-view-booking').parent().css('display', 'none');
					$('#navbarNav .mobile-check-in').parent().css('display', 'none');
					$('#navbarNav .mob-mholiday-tab').css('display', 'none');
				}
				if (_self.isMHExplorer()) {
					var optionsCabin = document.querySelectorAll(".cabin-class-mob .selectize-dropdown-content .option");
					var values = $.map(optionsCabin, function (option: any) {
						if (option.dataset.value != "CFFECO") {
							option.classList.add("hidden");
						}
					});	
					let $cabinClass: any = $('.cabin-class-mob');
					$cabinClass[0].selectize.setValue("CFFECO");

					let $fromLocationMobileInput:any = _self.$instance.find('.ibe-mob-from--location-input');		
					let $toLocationMobileInput: any = _self.$instance.find('.ibe-mob-to--location-input');		
					let $fromLocationInputMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
					let $toLocationInputMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');	

					$fromLocationInputMobTitle.removeClass('input-filled');
					$fromLocationMobileInput.html('<div></div>');		
					$toLocationInputMobTitle.removeClass('input-filled');
					$toLocationMobileInput.html('<div></div>');
					_self.bcommon.updateMOTAirportList($(_self.$instance), '.ibe-mob-from--location', '.ibe-mob-to--location');
				}
		});
		// update ond in case of flight tab clicked 
		$ibeNavList.click(function (event: any) {
			if (!event.currentTarget.classList.contains('mob-flysiswa')) {
				$('.mob-flysiswa-voucher-info .click-to-reveal').html('click to reveal');
				$('.mob-flysiswa-voucher-info .click-to-reveal').removeClass('has-error');
			}
			if (event.currentTarget.classList.contains('mobile-book-flight')) {
				if (_self.isMHExplorer()) {
					var optionsCabin = document.querySelectorAll(".cabin-class-mob .selectize-dropdown-content .option");
					var values = $.map(optionsCabin, function (option: any) {
						option.classList.remove("hidden");
	
					});
					let $cabinClass: any = $('.cabin-class-mob');
					$cabinClass[0].selectize.setValue("CFFECO");
					let $fromLocationMobileInput:any = _self.$instance.find('.ibe-mob-from--location-input');		
					let $toLocationMobileInput: any = _self.$instance.find('.ibe-mob-to--location-input');		
					let $fromLocationInputMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
					let $toLocationInputMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');	
	
					$fromLocationInputMobTitle.removeClass('input-filled');
					$fromLocationMobileInput.html('<div></div>');		
					$toLocationInputMobTitle.removeClass('input-filled');
					$toLocationMobileInput.html('<div></div>');
					_self.bcommon.updateMOTAirportList($(_self.$instance), '.ibe-mob-from--location', '.ibe-mob-to--location');
				}
			}
		});
		// Enrich always on only for cash flow	
			$paymentMethodOptions.find('input[name="cash_miles_type"]').on('click', () => {
				_self.isEligibleEnrichAlwaysOn=false;
				_self.showEnrichAlwaysOnBanner();
			});

			const getCookie = (name: any) => {
				const value = `; ${document.cookie}`;
				const parts = value.split(`; ${name}=`);
				if (parts.length === 2) return parts.pop().split(';').shift();
			};
	
			$('.mob-flysiswa-voucher-info .click-to-reveal').click(function () {
				let flyerID = getCookie('flyerID');
				let enrichId = flyerID.slice(2);
				let data = {
					enrichId: enrichId,
					voucherCode: getCookie('voucherCode')
				}
				$.ajax({
					type: 'POST',
					url:'/bin/services/new/mhexplorer/flysiswa/showVoucherInfo',
					data: data,
					success: function(msg:any) {
						var json = null;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						} else {
							json = msg;
						}
						if (json.status === "OK") {
							$('.mob-flysiswa-voucher-info .click-to-reveal').html(json.pinCode);
						} else {
							$('.mob-flysiswa-voucher-info .click-to-reveal').addClass('has-error');
							$('.mob-flysiswa-voucher-info .click-to-reveal').html('Data is not available');
						}
					},
					error: function(error:any) {
						$('.mob-flysiswa-voucher-info .click-to-reveal').addClass('has-error');
						$('.mob-flysiswa-voucher-info .click-to-reveal').html('Something went wrong.');
					}
				});
			});
			// hide show flysiswa subsidy tab
			let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
			let studentDashboard = document.querySelector('.student-dashboard');
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				// show flysiswa tab
				if ($('.mob-flysiswa-tab') && getCookie('isFlysiswaUser') === 'true') {
					$('.mob-flysiswa-tab').removeClass('hide');
					let voucherCodeEle = $('#mobile-bookflight--container').find('.flysiswa-voucher-code');
					voucherCodeEle.html(getCookie('voucherCode'));
				}
			}

	}
		//checking for MH explorer page
		isMHExplorer():boolean{
			let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
			let studentDashboard = document.querySelector('.student-dashboard');
			if (studentEnrichIdCookieVal != null && studentDashboard != null) {
				return true;
			}
			else{
				return false
			}
		}
	showEnrichAlwaysOnBanner():void{
		let _self=this;
		 let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
		let cashFlowType =$('#mobile-bookflight--container input[name="cash_miles_type"]:checked').val();
		let $tripType = _self.$instance.find('.trip-type--container li.selected a').attr('data-triptype');
		if (!loginTokenCookieVal && _self.enrichAlwaysON=='true' && !_self.isMHExplorer() && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
			$(".enrichOnDiscountInformation").removeClass('hideclass');
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');

		}
		
		else if(_self.isEligibleEnrichAlwaysOn && loginTokenCookieVal && _self.enrichAlwaysON=='true' && !_self.isMHExplorer() && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
			$(".enrichOnDiscountInformation").addClass('hideclass');
			$(".enrichOnDiscountToggleContainer").removeClass('hideclass');
		}
		else {
			$(".enrichOnDiscountInformation").addClass('hideclass');
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');	
		}
	}
	/**
	 * @function init
	 * !!! Global
	 */
	init(): void {
		let _self = this;

		let $bookDateSelector: any = _self.$scopeMob.find('.book-date--selector');
		let $bannerEl:any        = $('.banner-container');
		let $bannerHeight:number = 0;

		let $alertContainer:any  = $('.alert-container');
		let $stickyNavHeight:number;
		let $stickyNavHeightMob:number;

		let $ibeNavList: any = $('#bookingNav li');

		const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');

		let $passengerDetails:any       = $('[data-mob-booking-passenger-details]');
		let $passengerDetailsActive:any = $('[data-mob-booking-passenger-details-selected]');

		let $mabHeader:any       = $('#mab-header');

		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();
		$bookDateSelector.removeClass('datepicker-selected');

		if ($('.enrich-revamp-subpage').length > 0) {
			if (window.innerWidth < 768) {
				$('.enrich-revamp .enrich-header').removeClass('hide');
				$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');
				$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
				$('.enrich-revamp .enrich-home-container').addClass('hide');
				$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
				$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
				$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');
			}
		}

		// double check in case multiple banners are loaded on page
		$bannerEl.each(function(i:number, el:any){
			 $bannerHeight += $(el).height();
		});

		if ($alertContainer.is(':visible')) {
			$stickyNavHeight = $alertContainer.height() + $mabHeader.height();
			$stickyNavHeightMob = $alertContainer.height() + $mabHeader.height() + $bannerHeight;
		} else {
			$stickyNavHeight = $mabHeader;
			$stickyNavHeightMob = $mabHeader.height() + $bannerHeight;
		}

		// if satisfy conditions on page load open bookflight ibe by default
		// no deeplink detected
		// deeplick detected
		let urlParams = _self.bcommon.getUrlVars(window.location.href);
		// check for flysiswa variable in URL
		const path = window.location.pathname;
		const flysiswaValue = $('#onlyShowFlysiswa').val();
		if (path.indexOf('student-portal') > 0 && flysiswaValue == 'true') {
			setTimeout(function() {
				$('#mab-bookingnav.mobile #bookingNav').find('.mob-flysiswa').trigger('click');
			}, 500)
		} else {
			if ($('body').hasClass('home')) {
				if (urlParams.ibe && urlParams.ibe !== 'bfl' ) {
					// hide book flight ibe since deep link for other ibes detected
					topNavIbe.hide();
					$ibeNavList.find('a.mobile-book-flight').parent().removeClass('selected');
				}
			} else {
				// hide book flight ibe
				topNavIbe.hide();
				$ibeNavList.find('a.mobile-book-flight').parent().removeClass('selected');
			}
		}
		if ($('.enrich-revamp').length > 0) {
			// $('.enrich-revamp .link-swipe-more').on('click', () => {
			// 	$('.enrich-revamp .enrich-header').removeClass('hide');	
			// 	$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
			// 	$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
			// 	// $('.enrich-revamp .enrich-home-container').addClass('hide');
			// 	$('.enrich-revamp .enrich-home-container').slideUp();
			// 	$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
			// 	if (window.innerWidth < 768) {
			// 		$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
			// 		$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');
			// 	}
			// });	
			// Swipe up more in mobile
			document.querySelector(".enrich-revamp .enrich-home-container").addEventListener('touchstart', _self.handleTouchStart, false);        
			document.querySelector(".enrich-revamp .enrich-home-container").addEventListener('touchmove', _self.handleTouchMove, false);                                  																																		
				
		}
		// checking whether user logged and enrich Always on configured
		// _self.showEnrichAlwaysOnBanner();

	}
	handleTouchStart(evt:any) {
		let _self = this;
		const firstTouch = getTouches(evt)[0];                                      
		this.xDown = firstTouch.clientX;                                      
		this.yDown = firstTouch.clientY;    
		 function getTouches(evt:any) {
			return evt.touches ||             // browser API
			evt.originalEvent.touches; // jQuery
		}
	}
	handleTouchMove(evt:any) {
		evt.preventDefault()
		let _self = this;
		if ( !_self.xDown || !_self.yDown ) {
			return;
		}
		
		var xUp = evt.touches[0].clientX;                                    
		var yUp = evt.touches[0].clientY;

		var xDiff = _self.xDown - xUp;
		var yDiff = _self.yDown - yUp;
																			
		if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
			if ( xDiff > 0 ) {
				/* right swipe */ 
			} else {
				/* left swipe */
			}                       
		} else {
			if ( yDiff > 0) {
				$('.enrich-revamp .enrich-header').removeClass('hide');	
				$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
				$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
				
				// $('.enrich-revamp .enrich-home-container').scrollTop();
				// $('.enrich-revamp .enrich-home-container').addClass('hide');
				$('.enrich-revamp .enrich-home-container').slideUp('fast', function(){
					if (window.innerWidth < 768) {
						$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
					}
				});
				if (window.innerWidth < 768) {
					$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');
				}
				$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
				
			} 
			// else { 
			// 	$('.enrich-revamp .enrich-header').removeClass('hide');	
			// 	$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
			// 	$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
			// 	$('.enrich-revamp .enrich-home-container').addClass('hide');
			// 	$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
			// 	if (window.innerWidth < 768) {
			// 		$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
			// 		$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');
			// 	}
			// }                                                                 
		}
		/* reset values */
		_self.xDown = null;
		_self.yDown = null;  
	}
	/**
	 * @function setInstance
	 * - set current booking form instance
	 * @param {any} obj - current form object
	 * !!! Properly scoped
	 */
	setInstance(obj:any) {
		let _self = this;
		return _self.$instance = $(obj);
	}

	/**
	 * @function getInstance
	 * retrieve currently assigned booking form instance
	 * @return {any} - current instance
	 */
	getInstance():any {
		let _self = this;
		console.log(_self.$instance);
		return;
	}

	/**
	 * @function passengerType
	 * !!! Properly scoped
	 */
	passengerType(): void {
		let _self = this;
		
		let $bookDateSelector    = _self.$instance.find('.book-date--selector');
		let $passengerDetails: any        = _self.$instance.find('[data-mob-booking-passenger-details]');
		let $passengerDetailsActive: any  = _self.$instance.find('[data-mob-booking-passenger-details-selected]');

		let $cabinClass          = _self.$instance.find('.cabinClass');
		let $psngTitleCaption    = $passengerDetailsActive.find('.title-caption');
		let $psngTotalPassengers = $passengerDetailsActive.find('.total-passengers');
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');

		$(document).on('click', function () {
			$passengerDetailsActive.hide();
		});

		$passengerDetails.click(function(e:any) {
			e.stopPropagation();
			$passengerDetailsActive.show();
			$bookDateSelector.removeClass('datepicker-selected');
		});

		$passengerDetailsActive.on('mouseleave', function () {
			// $(this).hide();
		}).find('button, input').on('click', function (evt:any) {
			evt.stopPropagation();
		});

		let $psngEls = [$psngTitleCaption, $psngTotalPassengers, $cabinClass];

		$.each($psngEls, function(index:number, el:any ) {
			el.click(function(){
				$passengerDetailsActive.hide();
				$passengerDetails.addClass('passenger-focused');
				$passengerDetails.show();
				$passengerDetails.find('.total-passengers').show();
				$bookDateSelector.removeClass('datepicker-selected');
			});
		});
	}

/**
	 * @function recentSearch
	 * [recentSearch description]
	 * !!! Properly scoped
	 */
	recentSearch(): any {
		let _self = this;
		let $searchContainer = _self.$instance.find('.search-container');
		
		_self.$instance.find('.search-content').each(function(){
			let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
			let $searchItem = $(this);

			$searchItem.on('click', function(){
				let $fromCityCode: any     = $searchItem.find('.from-city--code').html();
				let $toCityCode: any       = $searchItem.find('.to-city--code').html();
				let $recentDepartDate: any = $searchItem.find('.from-date').attr('data-departDate');
				let $recentReturnDate: any = $searchItem.find('.to-date').attr('data-returndate');
				let $totalPassengersVal: any = $searchItem.find('.total-psngr').val();
				let $cabinClassVal: any	   = $searchItem.find('.cabin-hidden').val();
				let $cabinClass: any       = curInstance.find('.cabin-class-mob');
				let $fromLocation: any     = curInstance.find('.ibe-mob-from--location');
				let $toLocation: any       = curInstance.find('.ibe-mob-to--location');
				let $bookdateSelector:any  = curInstance.find('.book-date--selector');
				let $depRetTitle: any      = curInstance.find('.dep-return--title');
				let $totalPassenger: any   = curInstance.find('.total-passengers');
				let $passengerSplit: any   = curInstance.find('.booking-category');
				
				_self.recentSearchActive = true;
				/* Recent search - Check one way*/
				let $deptDateExist:any = $searchItem.find('.date .to-date');
				let $getTripType:any = curInstance.find('.trip-type--container');
				let $passengerValArr:any;

				if (!$deptDateExist.length){
					$getTripType.find('.oneWayTrip').trigger('click');
				} else {
					$getTripType.find('.returnTrip').trigger('click');
				}

				$searchContainer.show();
				$('.evo-autocomplete--static-mob').hide();

				// assign "to location" value to prepop into class variable
				// (to await completion of updating "from location")
				// following which the "to location" value will be populated
				//_self.toPrepop = $toCityCode;
				
			//	_self.toCityFromCookie = $toCityCode;
				if($totalPassengersVal === "undefined"||undefined)
				{
					$totalPassengersVal = "1|0|0|0|0";
				}

				$passengerValArr = $totalPassengersVal.split("|");
				$totalPassenger.find('.total-nos').html($passengerValArr[0]);
				$passengerSplit.find('.ticket-adult--input').val($passengerValArr[1]);
				$passengerSplit.find('.ticket-child--input').val($passengerValArr[2]);
				$passengerSplit.find('.ticket-infant--input').val($passengerValArr[3]);
				$passengerSplit.find('.ticket-mob-adult--input').val($passengerValArr[1]);
				$passengerSplit.find('.ticket-mob-child--input').val($passengerValArr[2]);
				$passengerSplit.find('.ticket-mob-infant--input').val($passengerValArr[3]);
				$passengerSplit.find('.ticket-mob-teenager--input').val($passengerValArr[4]);
				
				$cabinClass[0].selectize.setValue($cabinClassVal);
				$fromLocation[0].selectize.setValue($fromCityCode);
				$toLocation[0].selectize.setValue($toCityCode);
				$depRetTitle.find('.date-form--title').addClass('input-filled');
				
                let today:any ;
	            let dd:any;
                let yyyy:any;
	            today= new Date();
                dd = today.getDate();
                let mm = today.getMonth()+1; 
                yyyy = today.getFullYear();
                if(dd<10) 
                {
                  dd='0'+dd;
                } 

                if(mm<10) 
                {
                 mm='0'+mm;
                } 
                today = mm+'-'+dd+'-'+yyyy;
                var t=Date.parse(today);
                var recentDepartDate=Date.parse($recentDepartDate);
                var recentReturnDate=Date.parse($recentReturnDate);
                $bookdateSelector.find('.departureDateMobile').val($recentDepartDate);
                $bookdateSelector.find('.returnDateMobile').val($recentReturnDate);

				if (t>recentDepartDate) 
				{
				$bookdateSelector.find('.departureDateMobile').val("");
			    }
				if(t>recentReturnDate)
				{
                   $bookdateSelector.find('.returnDateMobile').val("");
                }

				setTimeout(function() {
					_self.recentSearchActive = false;
				}, 1000);
			});
			
			$searchItem.find('a.close-recent--item').on('click', function(){
				$searchItem.remove();
			});
		});
	}	/**
	 * @function ibeTripType
	 * !!! Properly scoped
	 */
	ibeTripType(): void {
		let _self = this;

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let returnDate = '';

		// return trip click event (mobile)
		curInstance.find('.trip-type--container .returnTrip').click(function(){
			setTimeout(function() {
				_self.siteTripButtonDisplay('return');
			}, 1000);

			returnTripClickHandler(this, curInstance);
		});

		// one way trip click event (mobile)
		curInstance.find('.trip-type--container .oneWayTrip').click(function(){
			setTimeout(function() {
				_self.siteTripButtonDisplay('oneWay');
			}, 1000);
			oneWayTripClickHandler(this, curInstance);
		});

		// side trip click event (mobile)
		curInstance.find('.trip-type--container .sideTrip').click(function(){
			sideTripClickHandler(this, curInstance);
		});

		// multi city trip click event (mobile)
		curInstance.find('.trip-type--container .multiCityTrip').click(function(){
			multiTripClickHandler(this, curInstance);
		});

		/*
		* return trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function returnTripClickHandler(el:any, instance:any) {
			let bdsRetTrip: any = instance.find('.book-date--selector.returnTrip');
			let bdsOneTrip: any = instance.find('.book-date--selector.oneWayTrip');
			let mobReturnTripDepartureDate:any = instance.find('.departureDateMobile');

			// clear select state on all trip type selectors
			$(el).parent().parent().find('li').removeClass('selected');
			$(el).addClass('selected');

			// toggle display of OnD fields
			bdsRetTrip.show();
			bdsOneTrip.hide();
			instance.find('.location-container.single-cityTrip--Container').show();
			instance.find('.location-container.mobile-multi-cityTrip--Container').hide();

			// remove filled state on input labels
			// bdsRetTrip.find('.dep-return--title .dep-title').removeClass('input-filled');
			// bdsRetTrip.find('.dep-return--title .ret-title').removeClass('input-filled');

			// empty input field
			//bdsRetTrip.find('.departureDateMobile').removeClass('date-filled').val('');
			//bdsRetTrip.find('.returnDateMobile').removeClass('date-filled').val('');
			if (returnDate != '') {
				bdsRetTrip.find('.returnDateMobile').val(returnDate);
			}
			if(instance.find('.sidetrippanel').is(":visible")) {
				instance.find('.sidetrippanel').hide();					
				instance.find('.mobile-search-form-submit').show();
			}
			if ($("#travel_pass").length > 0) {
				instance.find('.travel-pass-info-oneway').addClass('hide');
				instance.find('.travel-pass-info-return').removeClass('hide');
			}

			// show coupon code field
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);
			instance.find('.mobile-multi-city--bookflight').hide();

			//mobReturnTripDepartureDate.datepicker('setDate', $('#oneWayTripDateSelectorMob').find('.departureDateMobile').val()).trigger('blur', 'input');
			instance.find('.search-container.mobile-flight-widget').children(':first-child').show();
			_self.showEnrichAlwaysOnBanner();
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function oneWayTripClickHandler(el:any, instance:any) {
			let bdsRetTrip: any = instance.find('.book-date--selector.returnTrip');
			let bdsOneTrip: any = instance.find('.book-date--selector.oneWayTrip');
			let mobOneWayTripDepartureDate = instance.find('.departureDateMobile');

			// clear select state on all trip type selectors
			$(el).parent().parent().find('li').removeClass('selected');
			$(el).addClass('selected');

			// toggle display of OnD fields
			bdsRetTrip.hide();
			bdsOneTrip.show();
			instance.find('.location-container.single-cityTrip--Container').show();
			instance.find('.location-container.mobile-multi-cityTrip--Container').hide();

			// remove filled state on input labels
			// bdsRetTrip.find('.dep-return--title .dep-title').removeClass('input-filled');
			// bdsRetTrip.find('.dep-return--title .ret-title').removeClass('input-filled');

			// empty input field
			//bdsRetTrip.find('.departureDateMobile').removeClass('date-filled').val('');
			//bdsRetTrip.find('.returnDateMobile').removeClass('date-filled').val('');
			returnDate = bdsRetTrip.find('.returnDateMobile').val();
			bdsRetTrip.find('.returnDateMobile').val('');

			// Retain the departure date selected for return trip
			//mobOneWayTripDepartureDate.datepicker('setDate', $('#returnTripDateSelectorMob').find('.departureDateMobile').val()).trigger('blur', 'input');
			if(instance.find('.sidetrippanel').is(":visible")) {
				instance.find('.sidetrippanel').hide();					
				instance.find('.mobile-search-form-submit').show();
			}
			// show coupon code field
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);
			instance.find('.mobile-multi-city--bookflight').hide();
			instance.find('.search-container.mobile-flight-widget').children(':first-child').show();
			if ($("#travel_pass").length > 0) {
				instance.find('.travel-pass-info-return').addClass('hide');
				instance.find('.travel-pass-info-oneway').removeClass('hide');
			}
			_self.showEnrichAlwaysOnBanner()
		}

		function sideTripClickHandler(el:any, instance:any) {
			$(el).parent().parent().find('li').removeClass('selected');
			$(el).addClass('selected');
			$('.container--main-header').hide();
			instance.find('.container--book-sidetrip').show();
			$('body').css({
				'position': 'fixed'                			
			});
			instance.find("#ibe_book_sidetrip .ibe-sidetrip-container > .search-container").addClass('show');
			let $getTripType:any = instance.find('.container--book-sidetrip .trip-type--container');
			instance.find('.container--book-sidetrip').find('.returnsideTrip').trigger('click');
			if(instance.find('.sidetrippanel').is(":visible")) {
				instance.find('.sidetrippanel').hide();					
				instance.find('.mobile-search-form-submit').show();
			}
			_self.showEnrichAlwaysOnBanner()
		}

		/**
		* multi trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function multiTripClickHandler(el:any, instance:any) {
			$(el).parent().parent().find('li').removeClass('selected');
			$(el).addClass('selected');


			// toggle display of OnD fields
			instance.find('.location-container.single-cityTrip--Container').hide();			
			instance.find('.location-container.mobile-multi-cityTrip--Container').show();

			// hide redemption payment method and uncheck it
			instance.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);

			// hide coupon code (no coupon available for multicity)
			instance.find('.couponCode').hide();

			instance.find('.sidetrippanel').hide();					
			instance.find('.mobile-search-form-submit').hide();
			instance.find('.mobile-multi-city--bookflight').show();
			instance.find('.search-container.mobile-flight-widget').children(':first-child').hide();

			// reset infant warning state on changing triptype
			//$warningAccepted.val('');
			_self.showEnrichAlwaysOnBanner()
		}

		// redemption submit button handlers
		let tripTypeContainer:any   = _self.$instance.find('.trip-type--container');
		let rdmSingleSubmitBtn:any = _self.$instance.find('.redemption-submit-btn-single');
		let rdmMultiSubmitBtn:any  = _self.$instance.find('.redemption-submit-btn-multi');

		rdmMultiSubmitBtn.hide();

		tripTypeContainer.find('.returnTrip').on('click', () => {
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();
		});

		tripTypeContainer.find('.oneWayTrip').on('click', () => {
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();
		});
	}


	/**
	 * expand this instance of ibe
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 * @author dominic <dominic.gan@mirumagency.com>
	 */
	expandIbe(instance:any):void {
		let $mobileBookFlightContainer: any = instance;
		let $showMobileCloseBtn:any = $mobileBookFlightContainer.find('.close-container .close-booking');
		let $showMobileToLocation:any = $mobileBookFlightContainer.find('.toLocation');
		let $showMobilePaymentContainer:any = $mobileBookFlightContainer.find('.payment-type-container');
		let $showMobileTripContainer:any = $mobileBookFlightContainer.find('.trip-container');
		let $showMobileSearchContainer:any = $mobileBookFlightContainer.find('.search-container');

		$mobileBookFlightContainer.addClass('expanded');
		$showMobileCloseBtn.addClass('expanded');
		$showMobileSearchContainer.show();
		$showMobileToLocation.show();
		$showMobilePaymentContainer.show();
		$showMobileTripContainer.show();
	}

	/**
	 * @function initSelectize
	 * @param {any} listItems [description]
	 * !!! Properly scoped
	 */
	initSelectize(listItems:any, listToItems:any): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let $fromLocationMobileInput:any = _self.$instance.find('.ibe-mob-from--location-input');
		let $fromLocationMobile:any = _self.$instance.find('.ibe-mob-from--location');
		let $toLocationMobileInput:any = _self.$instance.find('.ibe-mob-to--location-input');
		let $toLocationMobile:any   = _self.$instance.find('.ibe-mob-to--location');
		let $toLocationMobileById:any     = _self.$instance.find('#ibeToLocationMobile');

		let $returnTripDateSelectorMobById:any     = _self.$instance.find('#returnTripDateSelectorMob');
 		let $oneWayTripDateSelectorMobById:any     = _self.$instance.find('#oneWayTripDateSelectorMob');

		let $fromLocationMobTitle:any       = $fromLocationMobile.parent().find('.booking-form--title');
		let $fromLocationSelectizeInput:any = $fromLocationMobile.parent().find('.selectize-control .selectize-input');

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $cugParam:any = $('#search-param-cug').val();
		let $studentPortalDashboard:boolean =false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
		let ukCities: any;
        let $isEnableCNN: any = $('#isEnableCNN');
        if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
            ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
        }
        else {
            ukCities = [];
        }			
		if(studentEnrichIdCookieVal != null && studentDashboard != null){
			$studentPortalDashboard  = true;
		}
		let $recentHide:any =false;
		$fromLocationMobile.html(listItems);
			/**
		 * [getCookieByMatch description]
		 * @param {string} regex [description]
		 */
		function getCookieByMatch(regex:RegExp) {
			let cs:any = document.cookie.split(/;\s*/),
					ret:Array<any> = [];
			for (var i:number = 0; i < cs.length; i++) {
				if (cs[i].match(regex)) {
					ret.push(cs[i]);
				}
			}
			return ret ;
		}

		function showDatesInCalender() {
			if(!$('#oneWayTripDateSelectorMob').is(':visible')) {
				if ( $('#returnTripDateSelectorMob').find('.departureDateMobile').val()=='') {
					$returnTripDateSelectorMobById.find('input[name="ReturnTripStartMobile"]').focus();
				}
			} else {
				if ( $('#oneWayTripDateSelectorMob').find('.departureDateMobile').val()=='') {
					$oneWayTripDateSelectorMobById.find('input[name="OneWayTripMobile"]').focus();
				}
			}
		}

		let fetchDatesForTravel = (fromval, toVal, type) => {
			return new Promise((resolve, reject) => {
				try {
					_self.bcommon.fetchAvailability(fromval, toVal)
					.then((jsonData) => {
						if (Object.keys(jsonData).length !== 0) {
							if (type === 'departure') {
								_self.availableDatesForTravelPassDept = jsonData.data.results.map((result) => result.date);
							} else if (type === 'return') {
								_self.availableDatesForTravelPassReturn = jsonData.data.results.map((result) => result.date);
							}
						}
						resolve(); // Resolve the Promise once the data is processed
					})
					.catch((error) => {
						console.error('Error fetching availability:', error);
						if (type === 'departure') {
							_self.availableDatesForTravelPassDept = [];
						} else if (type === 'return') {
							_self.availableDatesForTravelPassReturn = [];
						}
						reject(error); // Reject the Promise if an error occurs
					});
				} catch(e) {
					console.log(e);
					if (type === 'departure') {
						_self.availableDatesForTravelPassDept = [];
					} else if (type === 'return') {
						_self.availableDatesForTravelPassReturn = [];
					}
					reject(e); // Reject the Promise if an error occurs
				}
			});
		};

		$fromLocationMobileInput.magnificPopup({
			items: {
				src: '#mobile-location-popup'
			},			
			type: 'inline',			
			preloader: false,
			alignTop: true,			
			showCloseBtn: true,					
			callbacks: {
				open: function() {
					let instance = this;
					let $el: any = instance.content;
					$('#mobile-location-popup .selectize-input')[0].click();
					$('#mobile-location-popup .selectize-input')[0].focus();
					if ($fromLocationMobile.text() === '') {
						$("#mobile-from-title").show();				
					}else{
						$("#mobile-from-title").hide();	
					}
					if (window.innerWidth < 768) {
						$el.css({ 'padding': '0', 'height': '100%' });
						$el.parent().css({ 'height': '100%' });
						$el.parent().parent().css({ 'padding': '0' });
						$el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
						$el.find('#mobile-bookflight--container').css({ 'height': '100%' });
						$('body').css('height', $(window).height());
						$('body').css('overflow', 'hidden');
					}
				},
				close: function () {
					$('body').css('overflow', '');
					$('body').css('height', '');
				},
				afterClose: function () {
					const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');
					let $ibeNavList: any = $('#bookingNav li');
					topNavIbe.show();
					$ibeNavList.find('a.mobile-book-flight').parent().addClass('selected');
					if (!curInstance.find('.trip-type--container .returnTrip').hasClass('selected') && !curInstance.find('.trip-type--container .oneWayTrip').hasClass('selected')){
						curInstance.find('.trip-type--container .returnTrip').trigger('click');
					}
					if ($fromLocationMobile.text() !== "") {
						$('body').append('<span id="search_recentpayment" style="display:none">new-dynamic-text</span>');
							if($fromLocationMobile.text().trim().split('|')[17]=='MC')
							{
								$('input[value="cash_miles"]').prop("checked", true).trigger("click");
							}
							else if($fromLocationMobile.text().trim().split('|')[17]=='M')
							{
								$('input[value="miles"]').prop("checked", true).trigger("click");
							}
							else if($fromLocationMobile.text().trim().split('|')[17]=='C')
							{
								$('input[value="cash"]').prop("checked", true).trigger("click");
							}
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.addClass('input-filled');
						if ($fromLocationMobile.text().trim().split('|')[0] === 'Recent') {
							let $bookdateSelector: any = curInstance.find('.book-date--selector');
							let $depRetTitle: any = curInstance.find('.dep-return--title');
							let $totalPassenger: any = curInstance.find('.total-passengers');
							let $passengerSplit: any = curInstance.find('.booking-category');
							let $getTripType: any = curInstance.find('.trip-type--container');
							let $cabinClass: any = curInstance.find('.cabin-class-mob');
							let $passengerValArr: any;

							if ($fromLocationMobile.text().trim().split('|')[7] === "undefined" || undefined) {
								$getTripType.find('.oneWayTrip').trigger('click');
							} else {
								$getTripType.find('.returnTrip').trigger('click');
							}

							$totalPassenger.find('.total-nos').html($fromLocationMobile.text().trim().split('|')[12] ? $fromLocationMobile.text().trim().split('|')[12] : "1");
							$passengerSplit.find('.ticket-mob-adult--input').val($fromLocationMobile.text().trim().split('|')[13] ? $fromLocationMobile.text().trim().split('|')[13] : "0");
							$passengerSplit.find('.ticket-mob-child--input').val($fromLocationMobile.text().trim().split('|')[14] ? $fromLocationMobile.text().trim().split('|')[14] : "0");
							$passengerSplit.find('.ticket-mob-infant--input').val($fromLocationMobile.text().trim().split('|')[15] ? $fromLocationMobile.text().trim().split('|')[15] : "0");
							$passengerSplit.find('.ticket-mob-teenager--input').val($fromLocationMobile.text().trim().split('|')[16] ? $fromLocationMobile.text().trim().split('|')[16] : "0");
							let $cabinClassval = $fromLocationMobile.text().trim().split('|')[11];

							if($cabinClassval=="CFFFMC" || $cabinClassval=="CFFFMILES"){
								$cabinClassval= "CFFFIRST"
							} 
							else if($cabinClassval=="CFFJMC" || $cabinClassval=="CFFJMILES" || $cabinClassval=="CFFSTUBUS"){
								$cabinClassval= "CFFBUS"
							} 
							else if($cabinClassval =="CFFYMC" || $cabinClassval =="CFFYMILES" || $cabinClassval=="CFFSTUECO"){
								$cabinClassval= "CFFECO"
							}

							$cabinClass[0].selectize.setValue($cabinClassval);
							$depRetTitle.find('.date-form--title').addClass('input-filled');

							let today: any;
							let dd: any;
							let yyyy: any;
							today = new Date();
							dd = today.getDate();
							let mm = today.getMonth() + 1;
							yyyy = today.getFullYear();
							if (dd < 10) {
								dd = '0' + dd;
							}

							if (mm < 10) {
								mm = '0' + mm;
							}
							today = mm + '-' + dd + '-' + yyyy;
							var t = Date.parse(today);
							var recentDepartDate = Date.parse($fromLocationMobile.text().trim().split('|')[6]);
							if ($fromLocationMobile.text().trim().split('|')[8] !== "undefined" || undefined) {
								var recentReturnDate = Date.parse($fromLocationMobile.text().trim().split('|')[8]);
								$bookdateSelector.find('.returnDateMobile').val($fromLocationMobile.text().trim().split('|')[8]);
							}
							$bookdateSelector.find('.departureDateMobile').val($fromLocationMobile.text().trim().split('|')[6]);

							if (t > recentDepartDate) {
								$bookdateSelector.find('.departureDateMobile').val("");
							}
							if ($fromLocationMobile.text().trim().split('|')[8] !== "undefined" || undefined) {
								if (t > recentReturnDate) {
									$bookdateSelector.find('.returnDateMobile').val("");
								}
							}

							$fromLocationMobileInput.html('<div>' +
								($fromLocationMobile.text() ? '<span class = "airportname airportselected">' + $fromLocationMobile.text().trim().split('|')[2] + ' (' + $fromLocationMobile.text().trim().split('|')[1] + ')</span>': '') +
								'</div>');
							let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
							$toLocationMobTitle.addClass('input-filled');
							$toLocationMobileInput.html('<div>' +
								($fromLocationMobile.text() ? '<span class = "airportname airportselected">' + $fromLocationMobile.text().trim().split('|')[4] + ' (' + $fromLocationMobile.text().trim().split('|')[3] + ')</span>': '') +
								'</div>');
							$toLocationMobile.val($fromLocationMobile.text().trim().split('|')[3]);
							$toLocationMobile[0].selectize.setValue($fromLocationMobile.text().trim().split('|')[3]);
						} else {
							$fromLocationMobileInput.html('<div>' +
								($fromLocationMobile.text() ? '<span class = "airportname airportselected">' + $fromLocationMobile.text().trim().split('|')[0] + ' (' + $fromLocationMobile.text().trim().split('|')[2] + ')</span>': '') +
								'</div>');
								$.magnificPopup.open({
									items: {
										src: '#mobile-to-location-popup'
									},			
									type: 'inline',			
									preloader: false,
									alignTop: true,			
									showCloseBtn: true,					
									callbacks: {
										open: function() {
											let instance = this;
											let $el: any = instance.content;
											$('#mobile-to-location-popup .selectize-input')[0].click();
											$('#mobile-to-location-popup .selectize-input')[0].focus();
											if ($toLocationMobile.text() === '') {
												$("#mobile-to-title").show();				
											}else{
												$("#mobile-to-title").hide();	
											}
											$fromLocationMobTitle.addClass('input-filled');
											$fromLocationSelectizeInput.addClass('select-filled');
											let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];
											let cashFlowType = curInstance.find('input[name="cash_miles_type"]:checked').val();
											if (cashFlowType == "miles" || cashFlowType == "cash_miles") {
												bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
											} else {
												let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
												let studentDashboard = document.querySelector('.student-dashboard');
												if (studentEnrichIdCookieVal != null && studentDashboard != null) {
													bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
												} else {
													bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", ibeFromLocationValMobile, $toLocationMobile);
												}
											}
											if (ibeFromLocationValMobile != "" && !_self.recentSearchActive) {
												setTimeout(function () {
													$toLocationMobileById.find('input[type="select-one"]').focus();
													$toLocationMobTitle.addClass('input-filled');
													$toLocationSelectizeInput.addClass('select-filled');
												}, 300);
											}
											if (window.innerWidth < 768) {
												$el.css({ 'padding': '0', 'height': '100%' });
												$el.parent().css({ 'height': '100%' });
												$el.parent().parent().css({ 'padding': '0' });
												$el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
												$el.find('#mobile-bookflight--container').css({ 'height': '100%' });
												$('body').css('height', $(window).height());
												$('body').css('overflow', 'hidden');
											}
										},
										close: function () {
											$('body').css('overflow', '');
											$('body').css('height', '');
										},
										afterClose: function() {	
											let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];

                  							const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');
											let $ibeNavList: any = $('#bookingNav li');					
											topNavIbe.show();		
											$ibeNavList.find('a.mobile-book-flight').parent().addClass('selected');
											if ($toLocationMobile.text() !== "") {
												let $toLocationMobTitle:any       = $toLocationMobileInput.parent().find('.booking-form--title');
												$toLocationMobTitle.addClass('input-filled');
												$toLocationMobileInput.html('<div>' +
													($toLocationMobile.text() ? '<span class = "airportname airportselected">' + $toLocationMobile.text().trim().split('|')[0] + ' (' + $toLocationMobile.text().trim().split('|')[2] + ')</span>': '') +
													'</div>');							
											} else {
												let $toLocationMobTitle:any       = $toLocationMobileInput.parent().find('.booking-form--title');
												$toLocationMobTitle.removeClass('input-filled');
												$toLocationMobileInput.html('<div></div>');
											}					
										}				
									}
								}, 0);		
						}
					} else {
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.removeClass('input-filled');
						$fromLocationMobileInput.html('<div></div>');
					}
				$('#search_recentpayment').remove();
				}
			}
		}, 0);

		$toLocationMobileInput.magnificPopup({
			items: {
				src: '#mobile-to-location-popup'
			},			
			type: 'inline',			
			preloader: false,
			alignTop: true,			
			showCloseBtn: true,					
			callbacks: {
				open: function() {
					let instance = this;
					let $el: any = instance.content;
					$('#mobile-to-location-popup .selectize-input')[0].click();
					$('#mobile-to-location-popup .selectize-input')[0].focus();
					if ($toLocationMobile.text() === '') {
						$("#mobile-to-title").show();				
					}else{
						$("#mobile-to-title").hide();	
					}
					$fromLocationMobTitle.addClass('input-filled');
					$fromLocationSelectizeInput.addClass('select-filled');
					let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];
					let cashFlowType = curInstance.find('input[name="cash_miles_type"]:checked').val();
					if (cashFlowType == "miles" || cashFlowType == "cash_miles") {
						bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
					} else {
						let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
						let studentDashboard = document.querySelector('.student-dashboard');
						if (studentEnrichIdCookieVal != null && studentDashboard != null) {
							bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
						} else {
							bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", ibeFromLocationValMobile, $toLocationMobile);
						}
					}
					if (ibeFromLocationValMobile != "" && !_self.recentSearchActive) {
						setTimeout(function () {
							$toLocationMobileById.find('input[type="select-one"]').focus();
							$toLocationMobTitle.addClass('input-filled');
							$toLocationSelectizeInput.addClass('select-filled');
						}, 300);
					}
					if (window.innerWidth < 768) {
						$el.css({ 'padding': '0', 'height': '100%' });
						$el.parent().css({ 'height': '100%' });
						$el.parent().parent().css({ 'padding': '0' });
						$el.find('.mobile-ibe').css({ 'height': '100%', 'padding': '0' });
						$el.find('#mobile-bookflight--container').css({ 'height': '100%' });
						$('body').css('height', $(window).height());
						$('body').css('overflow', 'hidden');
					}
				},
				close: function () {
					$('body').css('overflow', '');
					$('body').css('height', '');
				},
				afterClose: function() {	
					const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');
					let $ibeNavList: any = $('#bookingNav li');					
					topNavIbe.show();
					let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];		
					$ibeNavList.find('a.mobile-book-flight').parent().addClass('selected');
					if ($toLocationMobile.text() !== "") {
						let $toLocationMobTitle:any       = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.addClass('input-filled');
						$toLocationMobileInput.html('<div>' +
							($toLocationMobile.text() ? '<span class = "airportname airportselected">' + $toLocationMobile.text().trim().split('|')[0] + ' (' + $toLocationMobile.text().trim().split('|')[2] + ')</span>' : '') +
							'</div>');							
					} else {
						let $toLocationMobTitle:any       = $toLocationMobileInput.parent().find('.booking-form--title');
						$toLocationMobTitle.removeClass('input-filled');
						$toLocationMobileInput.html('<div></div>');
					}					
				}				
			}
		}, 0);		

		$(document).on('click', '.mfp-close', function (e: any) {
			e.preventDefault();
			e.stopPropagation();
			$.magnificPopup.close();				
		});

		$fromLocationMobile.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($fromLocationMobile[0].selectize);
			},
			onFocus: function() {
				$fromLocationMobTitle.addClass('input-filled');
				$fromLocationSelectizeInput.addClass('select-filled');
				$fromLocationSelectizeInput.removeClass('has-error');
				$fromLocationMobTitle.removeClass('has-error');
				let $fromLocationChange = $fromLocationMobile.find('option:selected').text();
				let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);
				if($fromLocationChange !== '') {
					$fromLocationMobile[0].selectize.clear();
					$("#mobile-from-title").show();
				}

				if (recentSearchCookieArr.length > 0 && $cugParam != "CUG" && $studentPortalDashboard == false && $('#members-travel--subsidy').length < 1 && $('#ibe-standalone-iframe').length < 1) {
					if ($fromLocationChange == '') {
						// $('.evo-autocomplete--static-mob').show();
						// $(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").hide();
					} else {
						$('.evo-autocomplete--static-mob').hide();
						$(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").show();
					}
				}
				// if (($('#ibe-standalone-travelpass').length) > 0) {
				// 	$("html, body").animate({ scrollTop: $(document).height()},1000);
				// }
			},
			onDropdownOpen: function ($dropdown:any) {
			},
			onChange: function(value:any) {
							//#region enrich always on
					let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);
					// check user logged in && enrich always on 
					let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
					let cashFlowType = curInstance.find('input[name="cash_miles_type"]:checked').val();
					let $tripType = $('.trip-type--container li.selected a').attr('data-triptype');
					if(_self.enrichAlwaysON=='true'&& !_self.isMHExplorer() && loginTokenCookieVal && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
						_self.ONDenrichFromLocation($fromLocationMobile[0].selectize.options[value]);	
					}
					// fixed under this tkt : 32529
					// if recent is present then forcefolly call to location onchange method, only for cobrand
					if ($fromLocationMobile.text().trim().split('|')[0] == 'Recent' && 
						($('#ibe-standalone_cobrand').length > 0 && !$('#ibe-standalone_cobrand').hasClass('mfp-hide'))
					) {
						// ['Recent', 'AKL', 'Auckland', 'BLR', 'Bengaluru', '31/07',
						// '31 Jul 2024', '13/08', '13 Aug 2024', 'New Zealand', 'India',
						// 'CFFECO', '1', '1', '0', '0', '0', 'C', 'EAON']
						let recentSearchValues = $fromLocationMobile.text().trim().split('|');
						let destinationSelectize  = $toLocationMobile[0].selectize;
						destinationSelectize.setValue(recentSearchValues[3]);
            			destinationSelectize.trigger('change');
						// set dept date if trip type is return
						if ($tripType.toLowerCase() === "r") {
							$("#returnTripDateSelectorMob .departureDateMobile").datepicker("setDate", recentSearchValues[6]);
							$("#returnTripDateSelectorMob .returnDateMobile").datepicker("setDate", recentSearchValues[8]);
							$('#returnTripDateSelectorMob .dep-title').addClass('input-filled');
							$('#returnTripDateSelectorMob .ret-title').addClass('input-filled');
						}
						if ($tripType.toLowerCase() === "o") {
							$("#oneWayTripDateSelectorMob .departureDateMobile").datepicker("setDate", recentSearchValues[6]);
							$('#oneWayTripDateSelectorMob .dep-title').addClass('input-filled');
						}
						// set cabin class
						let cabinClass = $cabinSelected[0].selectize;
						cabinClass.setValue(recentSearchValues[11]);
            			cabinClass.trigger('change');
						// set passanger
						let $totalPassenger = _self.$instance.find('.total-passengers');
						$totalPassenger.find('.total-nos').html(recentSearchValues[12]);
						let $passengerDetailsActive:any = _self.$instance.find('[data-mob-booking-passenger-details-selected]');
						$passengerDetailsActive.find('.ticket-mob-adult--input').val(recentSearchValues[13]);
						$passengerDetailsActive.find('.ticket-mob-infant--input').val(recentSearchValues[15]);
						$passengerDetailsActive.find('.ticket-mob-child--input').val(recentSearchValues[14]);
						if ($passengerDetailsActive.find('.ticket-mob-teenager--input').length > 0) {
							$passengerDetailsActive.find('.ticket-mob-teenager--input').val(recentSearchValues[16]);
						}
					}
				//#endregion
				$fromLocationMobTitle.addClass('input-filled');
				$fromLocationSelectizeInput.addClass('select-filled');
				let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];
				if( $fromLocationMobile.text().trim().split('|')[0]!='' &&  $toLocationMobile.val()!='' ){
					_self.bcommon.lawfareAPI($fromLocationMobile.text().trim().split('|')[2],$toLocationMobile.val());
				}
				if (ukCities.includes(ibeFromLocationValMobile) || ukCities.includes($toLocationMobile.val().split('_')[0])) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.passenger-details-selected .isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.passenger-details-selected .isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					// fix for co brand recent search
					if (!($fromLocationMobile.text().trim().split('|')[0] == 'Recent' &&
						($('#ibe-standalone_cobrand').length > 0 && !$('#ibe-standalone_cobrand').hasClass('mfp-hide')))
					) {
						_self.$instance.find('.passenger-details-selected .ticket-mob-teenager--input').val(0).trigger('change');
					}
				}
				if ($('#ibe-standalone-travelpass').length < 1) {
					if (cashFlowType == "miles" || cashFlowType == "cash_miles") {
						bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
					} else {
						let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
						let studentDashboard = document.querySelector('.student-dashboard');
						if (studentEnrichIdCookieVal != null && studentDashboard != null) {
							bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationValMobile, $toLocationMobile);
						} else {
							bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", ibeFromLocationValMobile, $toLocationMobile);
						}
					}
				} else {
					let $travelPassZone:any = $('#travel_pass').find('#travel-pass--id');
					var $data: any = {
						zone: $travelPassZone.val().split('|')[3]
					};
					let airportlist = _self.bcommon.getTravelPassAirPorts($data);
					let $updateTypes:Array<any> = [];
					$updateTypes.push($toLocationMobile);
					_self.bcommon.updateTravelPassAirportList(ibeFromLocationValMobile, $updateTypes, airportlist);
				}
				if (ibeFromLocationValMobile != "" && !_self.recentSearchActive) {
					setTimeout(function() {
						if ($fromLocationMobile.text().trim().split('|')[0] !== 'Recent') {
							$toLocationMobileById.find('input[type="select-one"]').focus();
						}
						$toLocationMobTitle.addClass('input-filled');
						$toLocationSelectizeInput.addClass('select-filled');
					}, 300);
				}
				_self.expandIbe(curInstance);
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
				if ($('#mob_cobrand_ibe_value').length < 1 && ibeFromLocationValMobile !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1){
					$.magnificPopup.close();
				}	
				if(_self.$instance.find('.sidetrippanel').is(":visible")) {
					_self.$instance.find('.sidetrippanel').hide();					
					_self.$instance.find('.mobile-search-form-submit').show();
				}
				if(ibeFromLocationValMobile === '') {
					$fromLocationMobTitle.removeClass('input-filled');
					$fromLocationSelectizeInput.removeClass('select-filled');
				}
			},
			onBlur: function(){
				let $fromLocationChange = $fromLocationMobile.find('option:selected').text();
				if($recentHide == false){
					//$('.evo-autocomplete--static-mob').hide(); 
					}
				if ($fromLocationChange == ''){
					$fromLocationMobTitle.removeClass('input-filled');
					$fromLocationSelectizeInput.removeClass('select-filled');
				} else {
					$fromLocationMobTitle.addClass('input-filled');
					$fromLocationSelectizeInput.addClass('select-filled');
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
					if($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
						if ($.magnificPopup.instance.isOpen) {
							$.magnificPopup.close();
						}
					}					
				}
				$recentHide = false;
			},
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function(item:any, escape:any) {	
					if (item.text.split('|')[0] === 'Recent') {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[2].split('__')[0]) + ' ('+ escape(item.text.split('|')[1]) +')</span>' : '') +
							'</div>';
					} else {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' ('+ escape(item.text.split('|')[2]) + ')</span>' : '') +
							'</div>';
					}			
				},
				option: function(item:any, escape:any) {
					if (item.text.split('|')[0] === 'Recent') {
						let recentRetdate: string = (item.text.split('|')[8] !== "undefined"||undefined)? ' - ' + escape(item.text.split('|')[8]):'';
						let numberPax: string =  (item.text.split('|')[12] !== "undefined"||undefined)? ', ' + escape(item.text.split('|')[12]) + ' ' + '<i class="fa fa-user" aria-hidden="true"></i>': '';
						return '<div>' +
							(item.text ? '<p><span class = "airportname">' + escape(item.text.split('|')[2].split('__')[0]) +
								'</span> to <span class = "airportname">' + escape(item.text.split('|')[4].split('__')[0]) +
								'</span></p><p><span class = "recentdate">' +
								 escape(item.text.split('|')[6]) + recentRetdate + numberPax + '</span></p>': '') +
							'</div>';
					} else {
						return '<div>' +
							(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +
								'<span class = "airportcode">' +
								escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
							'</div>';
					}
				}
			}
		});
		
		$(".ibe-mob-from--location").keydown(function (event: any) {
			if (event.keyCode === 9) {
				event.preventDefault();
				event.stopPropagation();
			}
		});

		// $('.evo-autocomplete--static-mob').mousedown(function(e:any) {
		// 	$recentHide = true;
		// 	$('.evo-autocomplete--static-mob').show(); 
		//    });

		$("#mobile-location-popup .ibe-mob-from--location .selectize-input input").blur(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				e.preventDefault();
				$("#mobile-location-popup .ibe-mob-from--location .selectize-dropdown").show();
			}
		});

		$("#mobile-location-popup .ibe-mob-from--location .selectize-input input").focusout(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				e.preventDefault();
				$('#mobile-location-popup .selectize-input')[0].focus();
			}
		});		
		
		$("#mobile-bookflight--container .ibe-mob-from--location .selectize-input input").keyup(function(){ 
			
			if ($(".ibe-mob-from--location .selectize-input input").val() === '') {
				$("#mobile-from-title").show();
			} else {
				$("#mobile-from-title").hide();
			}
			//let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
			let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0 && $cugParam != "CUG" && $studentPortalDashboard == false && $('#members-travel--subsidy').length < 1 && $('#ibe-standalone-iframe').length < 1) {
				if ($(".ibe-mob-from--location .selectize-input input").val() == '') {
					// $('.evo-autocomplete--static-mob').show();
					// $(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").hide();
				} else {
					$('.evo-autocomplete--static-mob').hide();
					$(".ibe-mob-from--location .selectize-dropdown .selectize-dropdown-content").show();
				}
			}
		});
		$toLocationMobile.html(listToItems);

		let $toLocationMobTitle:any       = $toLocationMobile.parent().find('.booking-form--title');
		let $toLocationSelectizeInput:any;

		$toLocationMobile.selectize({
			onInitialize: function() {
				$('.isnt-uk').css('display', 'block');
				$('.passenger-details-selected .teenager-cat').css('display', 'none');
				$('.passenger-details-selected .is-uk').css('display', 'none');
				_self.wcag.selectizeInputAria($toLocationMobile[0].selectize);
				$toLocationSelectizeInput = $toLocationMobile[0].selectize.$control;

				// singleFromSelectizeReady.resolve();
				// for mh sports hide child and infant in passenger dropdown #29941
				if (athleteId != null) {
					$('.passenger-details-selected .child-cat').css('display', 'none');
					$('.passenger-details-selected .infant-cat').css('display', 'none');
					curInstance.find('.couponCode').css('display', 'none');
				}
			},
			onFocus: function() {
				$toLocationMobTitle.addClass('input-filled');
				$toLocationSelectizeInput.addClass('select-filled');
				$toLocationSelectizeInput.removeClass('has-error');
				$toLocationMobTitle.removeClass('has-error');
				let $toLocationChange = $toLocationMobile.find('option:selected').text();	
				if (!_self.isIbePrepop) {
					if ($toLocationChange !== '') {
						$toLocationMobile[0].selectize.clear();
						$("#mobile-to-title").show();
					}
				}
				_self.isIbePrepop = false;	
			},
			onDropdownOpen: function ($dropdown:any) {
			},
			onChange: function(value: any){
				//#region enrich always on
					// check user logged in && enrich always on 
			
					let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
					let cashFlowType = _self.$instance.find('input[name="cash_miles_type"]:checked').val();
					let $tripType = $('.trip-type--container li.selected a').attr('data-triptype');
					if(_self.enrichAlwaysON=='true'&& !_self.isMHExplorer() && loginTokenCookieVal && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
						_self.ONDenrichToLocation($toLocationMobile[0].selectize.options[value]);	
				}	
						
				//#endregion	
				$toLocationMobTitle.addClass('input-filled');
				let ibeFromLocationValMobile = $fromLocationMobile.val().trim().split('_')[0];
				$toLocationSelectizeInput.addClass('select-filled');
				if( $fromLocationMobile.text().trim().split('|')[0]!='' &&  $toLocationMobile.val()!='' ){
					_self.bcommon.lawfareAPI($fromLocationMobile.text().trim().split('|')[2],$toLocationMobile.val());
				}
				if (ukCities.includes(ibeFromLocationValMobile) || ukCities.includes($toLocationMobile.val().split('_')[0])) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.passenger-details-selected .isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.passenger-details-selected .isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					_self.$instance.find('.passenger-details-selected .ticket-mob-teenager--input').val(0).trigger('change');
				}
				// show error if from and to fields are the same and not empty
				if ($fromLocationMobile.val().trim().split('_')[0] === $toLocationMobile.val() && $fromLocationMobile.val().length > 0) {
					$toLocationSelectizeInput.addClass('has-error');
					$toLocationMobTitle.addClass('has-error');
				}
				else {
					$toLocationSelectizeInput.removeClass('has-error');
					$toLocationMobTitle.removeClass('has-error');
				}
				let toVal:any = $toLocationMobile.val().trim().split('|')[0];
				if ($toLocationMobile.val().trim() != "" && !_self.recentSearchActive) {
					if(_self.$instance.find('[data-widgetName="travelPass"]').length > 0) {
						function callback() {
							fetchDatesForTravel(toVal, $fromLocationMobile.val(), 'return')
								.then(() => {
									showDatesInCalender();
									_self.isIbePrepop = false;
								})
								.catch((error) => {
									console.error("Error fetching 'return' dates:", error);
									showDatesInCalender();
									_self.isIbePrepop = false;
								});
						}
						function fetchDeptAndReturndatesAvailablity() {
							fetchDatesForTravel($fromLocationMobile.val(), toVal, 'departure')
								.then(() => {
									callback();
								})
								.catch((error) => {
									console.error("Error fetching 'departure' dates:", error);
									callback();
							});
						}
						fetchDeptAndReturndatesAvailablity();
						
					} else {
						setTimeout(function() {
							_self.availableDatesForTravelPassDept = [];
							_self.availableDatesForTravelPassReturn = [];
							showDatesInCalender();
							_self.isIbePrepop = false;
						}, 200);
					}
				}
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length? $('#mini-ibe-cta-button').val() : '';
				if ($('#mob_cobrand_ibe_value').length < 1 && $toLocationMobile.val().trim() !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton =='' && $('#ibe-standalone-iframe').length < 1){
					$.magnificPopup.close();
				}	
				if(_self.$instance.find('.sidetrippanel').is(":visible")) {
					_self.$instance.find('.sidetrippanel').hide();					
					_self.$instance.find('.mobile-search-form-submit').show();
				}				
				
			},
			onBlur: function () {
				let $toLocationChange = $toLocationMobile[0].selectize.$input.val();
				if (!$toLocationChange.length) {
					$toLocationMobTitle.removeClass('input-filled');
					$toLocationSelectizeInput.removeClass('select-filled');
				} else {
					$toLocationMobTitle.addClass('input-filled');
					$toLocationSelectizeInput.addClass('select-filled');
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
					if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
						if ($.magnificPopup.instance.isOpen) {
							$.magnificPopup.close();
						}
					}
				}
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($toLocationMobile[0].selectize);
				//$toLocationMobile[0].selectize.trigger('blur');
				let $toLocationChange = $toLocationMobile[0].selectize.$input.val();
				if (!$toLocationChange.length){
					$toLocationMobTitle.removeClass('input-filled');
					$toLocationSelectizeInput.removeClass('select-filled');
				} else {
					$toLocationMobTitle.addClass('input-filled');
					$toLocationSelectizeInput.addClass('select-filled');					
				}
			},
			searchField: ['text'],
			selectOnTab: true,
			render: {
				item: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
					'</div>';				
				},
				option: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span></p><p>' + escape(item.text.split('|')[1]) + '</p>': '') +
					'</div>';
				}
			}
		});

		$("#mobile-bookflight--container .ibe-mob-to--location .selectize-input input").keyup(function(){ 			
			if ($(".ibe-mob-to--location .selectize-input input").val() === '') {
				$("#mobile-to-title").show();				
			}else{
				$("#mobile-to-title").hide();	
			}
		});

		$("#mobile-to-location-popup .ibe-mob-to--location .selectize-input input").blur(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				e.preventDefault();
				$("#mobile-to-location-popup .ibe-mob-to--location .selectize-dropdown").show();
			}
		});

		$("#mobile-to-location-popup .ibe-mob-to--location .selectize-input input").focusout(function (e: any) {
			let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
			if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '' && $('#ibe-standalone-iframe').length < 1) {
				e.preventDefault();
				$('#mobile-to-location-popup .selectize-input')[0].focus();
			}
		});
		
		let $cabinSelected:any = _self.$instance.find('.cabin-class-mob');
		$cabinSelected.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($cabinSelected[0].selectize);
				// set economy as default on load
				$cabinSelected[0].selectize.setValue('CFFECO');
			},
			onFocus: function() {
				$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
				curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onChange: function() {
				$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
				curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
				if(curInstance.find('.sidetrippanel').is(":visible")) {
					curInstance.find('.sidetrippanel').hide();					
					curInstance.find('.mobile-search-form-submit').show();
				}
			},
			onBlur: function(){
				let $cabinClassChange = $cabinSelected.find('option:selected').text();
				if ($cabinClassChange == ''){
					$cabinSelected.parent().find('.booking-form--title').removeClass('input-filled');
					curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$cabinSelected.parent().find('.booking-form--title').addClass('input-filled');
					curInstance.find('.cabin-class-mob.selectize-control.single .selectize-input').addClass('select-filled');
				}
			}
		});

		let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');
		let multiCityGrpArray: any = [];
		$multiCityDestGroup.each(function (i: number) {
			// MultiCity From Location event handlers
			let $mcityFromLocation: any = $(this).find('.multicity-from--location'),
				$mcityFromBookingTitle: any = $(this).find('.mc-from--location .booking-form--title'),
				$mcityFromSelectize: any,
				$mcityFromSelectInput: any = $(this).find('select.mc-from--location'),
				$bookdateSelector: any = $(this).find('.book-date--selector');
			let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instanc			

			let $fromLocationMobileInput: any = $(this).find('.multicity-from--location-input');
			let $toLocationMobileInput: any = $(this).find('.multicity-to--location-input');
			let $multicityFrompopup: any = $(this).find('.multicity-from--location-popup');
			let $multicityTopopup: any = $(this).find('.multicity-to--location-popup');

			$mcityFromLocation.html(listToItems);
			$mcityFromLocation.selectize({
				onInitialize: function () {
					_self.wcag.selectizeInputAria($mcityFromLocation[0].selectize);
					$mcityFromSelectize = $($mcityFromLocation[0].selectize.$control[0]);
				},
				onFocus: function () {
					_self.expandIbe(curInstance);
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityFromSelectize.removeClass('has-error');
					$mcityFromBookingTitle.removeClass('has-error');
					let $mcityfromLocationChange = $mcityFromLocation.find('option:selected').text();
					if ($mcityfromLocationChange !== '') {
						$mcityFromLocation[0].selectize.clear();
						$multicityFrompopup.find('.mob-booking-placeholder').show();
					}
				},
				onChange: function (value: any) {
					let mcityFromLocationValue: any = $mcityFromLocation.val().trim().split('_')[0];
					let mcityToLocationValue: any = $mcityToLocation.val().trim().split('_')[0];
					let j: any = 1;
					while (j < 7) {
						let frmVal: any = $('[name="mobMultiCityfromLocation' + j + '"]').val();
						multiCityGrpArray.push(frmVal);
						let toVal: any = $('[name="mobMultiCitytoLocation' + j + '"]').val();
						multiCityGrpArray.push(toVal);
						j++;
					}

					/* Handling passenger type for uk cities */
					if (ukCities.some(v => multiCityGrpArray.indexOf(v) !== -1)) {
						$('.passenger-details-selected .teenager-cat').css('display', 'block');
						$('.passenger-details-selected .is-uk').css('display', 'block');
						$('.isnt-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = true;
					} else {
						$('.isnt-uk').css('display', 'block');
						$('.passenger-details-selected .teenager-cat').css('display', 'none');
						$('.passenger-details-selected .is-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = false;
						_self.$instance.find('.passenger-details-selected .ticket-mob-teenager--input').val(0).trigger('change');
					}
					multiCityGrpArray.length = 0;
					let toLocationEl: any = $($multiCityDestGroup[i]).find('select.multicity-to--location');
					if (value.length) {
						// only get new toLocation values if fromLocation val is filled (do nothing if empty value)
						_self.bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", mcityFromLocationValue, toLocationEl);
					}
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
					if (_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
						_self.$instance.find('.ibe_freesidetrip').hide();
						_self.$instance.find('.multi-city--bookflight').show();
					}
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
					if (value.trim() !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
						$.magnificPopup.close();
					}
				},
				onBlur: function () {
					let $multiFromLocationVal = $mcityFromLocation.parent().find("option:selected").text();
					if ($multiFromLocationVal == '') {
						$mcityFromBookingTitle.removeClass('input-filled');
						$mcityFromSelectize.removeClass('select-filled');
					} else {
						$mcityFromBookingTitle.addClass('input-filled');
						$mcityFromSelectize.addClass('select-filled');
					}
				},
				onLoad: function (data: any) {
					$mcityFromLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text'],
				selectOnTab: true,
				render: {
					item: function (item: any, escape: any) {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
							'</div>';

					},
					option: function (item: any, escape: any) {
						return '<div>' +
							(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +
								'<span class = "airportcode">' +
								escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
							'</div>';
					}
				}
			});

			$multicityFrompopup.find('.multicity-from--location .selectize-input input').blur(function (e: any) {
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
				if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
					e.preventDefault();
					$multicityFrompopup.find('.multicity-from--location .selectize-dropdown').show();
				}
			});

			$multicityFrompopup.find('.multicity-from--location .selectize-input input').focusout(function (e: any) {
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
				if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
					e.preventDefault();
					$multicityFrompopup.find('.multicity-from--location .selectize-input')[0].focus();
				}
			});

			$multicityFrompopup.find('.multicity-from--location .selectize-input input').keyup(function () {

				if ($multicityFrompopup.find('.multicity-from--location .selectize-input input').val() === '') {
					$multicityFrompopup.find('.mob-booking-placeholder').show();
				} else {
					$multicityFrompopup.find('.mob-booking-placeholder').hide();
				}
			});

			/** MultiCity To Location event handlers*/
			let $mcityToLocation: any = $(this).find('.multicity-to--location'),
				$mcityToBookingTitle: any = $(this).find('.mc-to--location .booking-form--title'),
				$mcityToSelectize: any,
				$mcityToSelectInput: any = $(this).find('select.mc-to--location');

			$mcityToLocation.html(listToItems);
			$mcityToLocation.selectize({
				onInitialize: function () {
					_self.wcag.selectizeInputAria($mcityToLocation[0].selectize);
					$mcityToSelectize = $($mcityToLocation[0].selectize.$control[0]);
				},
				onFocus: function () {
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityToSelectize.removeClass('has-error');
					$mcityToBookingTitle.removeClass('has-error');
					let $mcitytoLocationChange = $mcityToLocation.find('option:selected').text();
					if ($mcitytoLocationChange !== '') {
						$mcityToLocation[0].selectize.clear();
						$multicityTopopup.find('.mob-booking-placeholder').show();
					}
				},
				onChange: function (value: any) {
					let mcityToLocationValue: any = $mcityToLocation.val().trim().split('_')[0];
					let j: any = 1;
					multiCityGrpArray = [];
					while (j < 7) {
						let toVal: any = $('[name="mobMultiCitytoLocation' + j + '"]').val();
						let frVal: any = $('[name="mobMultiCityfromLocation' + j + '"]').val();
						multiCityGrpArray.push(toVal);
						multiCityGrpArray.push(frVal);
						j++;
					}
					if (ukCities.some(v => multiCityGrpArray.indexOf(v) !== -1)) {
						$('.passenger-details-selected .teenager-cat').css('display', 'block');
						$('.passenger-details-selected .is-uk').css('display', 'block');
						$('.isnt-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = true;
					}
					else {
						$('.isnt-uk').css('display', 'block');
						$('.passenger-details-selected .teenager-cat').css('display', 'none');
						$('.passenger-details-selected .is-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = false;
					}
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					if ($mcityFromLocation.val().trim().split('_')[0] === $mcityToLocation.val()) {
						$mcityToSelectize.addClass('has-error');
						$mcityToBookingTitle.addClass('has-error');
					}
					else {
						$mcityToSelectize.removeClass('has-error');
						$mcityToBookingTitle.removeClass('has-error');
					}
					if (_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
						_self.$instance.find('.ibe_freesidetrip').hide();
						_self.$instance.find('.multi-city--bookflight').show();
					}
					let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
					if (value.trim() !== "" && $('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
						$.magnificPopup.close();
					}
				},
				onBlur: function () {
					let $multiToLocationVal = $mcityToLocation.parent().find("option:selected").text();
					if ($multiToLocationVal == '') {
						$mcityToBookingTitle.removeClass('input-filled');
						$mcityToSelectize.removeClass('select-filled');
					} else {
						$mcityToBookingTitle.addClass('input-filled');
						$mcityToSelectize.addClass('select-filled');
					}
				},
				onLoad: function (data: any) {
					_self.fillToPrepopValue($mcityToLocation[0].selectize);
					$mcityToLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text'],
				selectOnTab: true,
				render: {
					item: function (item: any, escape: any) {
						return '<div>' +
							(item.text ? '<span class = "airportname airportselected">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>' : '') +
							'</div>';
					},
					option: function (item: any, escape: any) {
						return '<div>' +
							(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' + '<span class = "airportcode">' + escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
							'</div>';
					}
				}
			});

			$multicityTopopup.find('.multicity-to--location .selectize-input input').blur(function (e: any) {
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
				if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
					e.preventDefault();
					$multicityTopopup.find('.multicity-to--location .selectize-dropdown').show();
				}
			});

			$multicityTopopup.find('.multicity-to--location .selectize-input input').focusout(function (e: any) {
				let miniibeCTAbutton: string = $('#mini-ibe-cta-button').length ? $('#mini-ibe-cta-button').val() : '';
				if ($('#members-travel--subsidy').length < 1 && miniibeCTAbutton == '') {
					e.preventDefault();
					$multicityTopopup.find('.multicity-to--location .selectize-input')[0].focus();
				}
			});

			$multicityTopopup.find('.multicity-to--location .selectize-input input').keyup(function () {

				if ($multicityTopopup.find('.multicity-to--location .selectize-input input').val() === '') {
					$multicityTopopup.find('.mob-booking-placeholder').show();
				} else {
					$multicityTopopup.find('.mob-booking-placeholder').hide();
				}
			});


			$fromLocationMobileInput.magnificPopup({
				items: {
					src: $multicityFrompopup
				},
				type: 'inline',
				preloader: false,
				alignTop: true,
				showCloseBtn: true,
				callbacks: {
					open: function () {
						let instance = this;
						let $el: any = instance.content;
						$el.find('.selectize-input')[0].click();
						$el.find('.selectize-input')[0].focus();
						if ($mcityFromLocation.text() === '') {
							$el.find('.mob-booking-placeholder').show();
						} else {
							$el.find('.mob-booking-placeholder').hide();
						}
						if (window.innerWidth < 768) {
							$el.css({ 'padding': '0', 'height': '100%' });
							$el.parent().css({ 'height': '100%' });
							$el.parent().parent().css({ 'padding': '0' });
							$('body').css('height', $(window).height());
							$('body').css('overflow', 'hidden');
						}
					},
					close: function () {
						$('body').css('overflow', '');
						$('body').css('height', '');						
					},
					afterClose: function () {
						if ($mcityFromLocation.text() !== "") {
							let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
							$fromLocationMobTitle.addClass('input-filled');
							$fromLocationMobileInput.parent().removeClass('has-error');
							$fromLocationMobileInput.parent().find('.booking-form--title').removeClass('has-error');
							$fromLocationMobileInput.html('<div>' +
								($mcityFromLocation.text() ? '<span class = "airportname airportselected">' + $mcityFromLocation.text().trim().split('|')[0] + ' (' + $mcityFromLocation.text().trim().split('|')[2] + ')</span>' : '') +
								'</div>');
							$.magnificPopup.open({
								items: {
									src: $multicityTopopup
								},
								type: 'inline',
								preloader: false,
								alignTop: true,
								showCloseBtn: true,
								callbacks: {
									open: function () {
										let instance = this;
										let $el: any = instance.content;
										$el.find('.selectize-input')[0].click();
										$el.find('.selectize-input')[0].focus();
										if ($mcityToLocation.text() === '') {
											$el.find('.mob-booking-placeholder').show();
										} else {
											$el.find('.mob-booking-placeholder').hide();
										}
										$fromLocationMobTitle.addClass('input-filled');
										$mcityFromLocation.find('.selectize-control.single .selectize-input').addClass('select-filled');
										let ibeFromLocationValMobile = $mcityFromLocation.val().trim().split('_')[0];

										if (window.innerWidth < 768) {
											$el.css({ 'padding': '0', 'height': '100%' });
											$el.parent().css({ 'height': '100%' });
											$el.parent().parent().css({ 'padding': '0' });
											$('body').css('height', $(window).height());
											$('body').css('overflow', 'hidden');
										}
									},
									close: function () {
										$('body').css('overflow', '');
										$('body').css('height', '');									
									},
									afterClose: function () {
										if ($mcityToLocation.text() !== "") {
											let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
											$toLocationMobTitle.addClass('input-filled');
											$toLocationMobileInput.parent().removeClass('has-error');
											$toLocationMobileInput.parent().find('.booking-form--title').removeClass('has-error');
											$toLocationMobileInput.html('<div>' +
												($mcityToLocation.text() ? '<span class = "airportname airportselected">' + $mcityToLocation.text().trim().split('|')[0] + ' (' + $mcityToLocation.text().trim().split('|')[2] + ')</span>' : '') +
												'</div>');
										} else {
											let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
											$toLocationMobTitle.removeClass('input-filled');
											$toLocationMobileInput.html('<div></div>');
										}
										$toLocationMobileInput.focus();
									}
								}
							}, 0);

						} else {
							let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
							$fromLocationMobTitle.removeClass('input-filled');
							$fromLocationMobileInput.html('<div></div>');
						}
						$fromLocationMobileInput.focus();
					}
				}
			}, 0);

			$toLocationMobileInput.magnificPopup({
				items: {
					src: $multicityTopopup
				},
				type: 'inline',
				preloader: false,
				alignTop: true,
				showCloseBtn: true,
				callbacks: {
					open: function () {
						let instance = this;
						let $el: any = instance.content;
						$el.find('.selectize-input')[0].click();
						$el.find('.selectize-input')[0].focus();
						if ($mcityToLocation.text() === '') {
							$el.find('.mob-booking-placeholder').show();
						} else {
							$el.find('.mob-booking-placeholder').hide();
						}
						$fromLocationMobTitle.addClass('input-filled');
						$mcityFromLocation.find('.selectize-control.single .selectize-input').addClass('select-filled');
						let ibeFromLocationValMobile = $mcityFromLocation.val().trim().split('_')[0];

						if (window.innerWidth < 768) {
							$el.css({ 'padding': '0', 'height': '100%' });
							$el.parent().css({ 'height': '100%' });
							$el.parent().parent().css({ 'padding': '0' });
							$('body').css('height', $(window).height());
							$('body').css('overflow', 'hidden');
						}
					},
					close: function () {
						$('body').css('overflow', '');
						$('body').css('height', '');						
					},
					afterClose: function () {
						if ($mcityToLocation.text() !== "") {
							let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
							$toLocationMobTitle.addClass('input-filled');
							$toLocationMobileInput.parent().removeClass('has-error');
							$toLocationMobileInput.parent().find('.booking-form--title').removeClass('has-error');
							$toLocationMobileInput.html('<div>' +
								($mcityToLocation.text() ? '<span class = "airportname airportselected">' + $mcityToLocation.text().trim().split('|')[0] + ' (' + $mcityToLocation.text().trim().split('|')[2] + ')</span>' : '') +
								'</div>');
						} else {
							let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
							$toLocationMobTitle.removeClass('input-filled');
							$toLocationMobileInput.html('<div></div>');
						}
						$toLocationMobileInput.focus();
					}
				}
			}, 0);

		});

		if (($('#ibe-standalone-travelpass').length) > 0) {
			let $cabinClassTravelPass: any = $('#ibe-standalone-travelpass').find('.cabin-class-mob');			
			let options = $cabinClassTravelPass[0].selectize.options;
			let destVars: any = Object.keys(options);

			destVars.forEach(function (destVar: any) {
				if (destVar !== 'CFFECO') {
					$cabinClassTravelPass[0].selectize.removeOption(destVar);
				}
			});			
		}

		let isSideTripEnabled =  $('#isSideTripEnable').val();
		if (isSideTripEnabled === 'Yes') {
			$("#mobile-bookflight--container .mobile-flight-widget:not([class*='passenger-details']) :input").change(function(evt:any) { 
				if(evt.target.classList.contains("minus-plus-input") === false){
					_self.siteTripButtonDisplay('');
				}
				
			});
		}
		
	}

	/*
	Function to display site trip button if eligible
	*/
	siteTripButtonDisplay(tripType:any): void {
		let isSideTripEnabled =  $('#isSideTripEnable').val();
		let type = $('input[name="cash_miles_type"]:checked').val();
		if(type === 'cash') {
		if (isSideTripEnabled === 'Yes') {
		let _self = this;
		let curInstance = _self.$instance;
		let $mobFromLocation:any = curInstance.find('.ibe-mob-from--location');
		let $mobToLocation:any = curInstance.find('.ibe-mob-to--location');
		let $passengerCnt:any = curInstance.find('input.total-tickets--value').val();
		let $cabinClass:any = curInstance.find('.cabin-class-mob').val();
		let $mobCouponCode = curInstance.find('.couponcode-input-mob').val();
		let $paymentMethod = curInstance.find('input[name="cash_miles_type"]:checked').val();
		
		let $oneWayTripEl:any  = curInstance.find('.trip-type--container .oneWayTrip'),
		$oneWayDepDate:any = curInstance.find('.oneWayTrip .departureDateMobile'),
		$returnDepDate:any = curInstance.find('.departureDateMobile'),
		$returnRetDate:any = curInstance.find('.returnDateMobile');
		let $formDataValid:any = true;
		let $formOneway:Boolean = false;
		if ($paymentMethod === 'cash') {
			if(tripType == ''){
				if ($oneWayTripEl.hasClass('selected')) {
					$formOneway = true;
				}
			}else{
				if(tripType == 'oneWay'){
					$formOneway = true;
				}
			}
			if ($formOneway === true) {
				if ($oneWayDepDate.val() == '') {
					$formDataValid= false;
				}
			}else{
				if ($returnDepDate.val() == '' || $returnRetDate.val() == ''){
					$formDataValid= false;
				}
			}
	
			if ($mobFromLocation.length > 0 && $mobFromLocation.val() != '' && $mobToLocation.length > 0 && $mobToLocation.val()!=='' && $passengerCnt !=0 && $cabinClass !='' && $mobCouponCode =='' && $formDataValid == true){
				if (_self.bookingFormSubmit.mobileSidetripEligibilityCheck(curInstance)) {
					curInstance.find('.sidetrippanel').show();
					curInstance.find('.mobile-search-form-submit').hide();
				}
			}	

		}
		}
	}
	}
	/**
	 * @function calendarComponent
	 * !!! Properly scoped
	 */
	calendarComponent(): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let nowDate:any      = new Date();
		let today:any        = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
		let maxLimitDate: any = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() + maxDays, 0, 0, 0, 0);

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		let $deviceHeight = $(window).height()/1.78;

		let $tripTypeContainer:any = _self.$instance.find('.trip-type--container');

		function highlightMobileDays(date: any) {
			var startDate = new Date(curInstance.find('.departureDateMobile').datepicker('getDate'));
			var endDate = new Date(curInstance.find('.returnDateMobile').datepicker('getDate'));

			if ((startDate <= date) &&  (date <= endDate)) {
				return [true, 'highlight'];
			} else {
				return [true, ''];
			}
		}
		function highlightForDateAvailablity(date: any, type: any) {
			if (_self.$instance.find('[data-widgetName="travelPass"]').length > 0) {
				const year = date.getFullYear();
				const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-indexed
				const day = ('0' + date.getDate()).slice(-2);
				const formattedDate = `${year}-${month}-${day}`;
				var highlightedDates = [];
				if (_self.$instance.find('[data-widgetName="travelPass"]') && type === 'dept'){
					highlightedDates = _self.availableDatesForTravelPassDept;
				} else {
					if (_self.$instance.find('[data-widgetName="travelPass"]') && type === 'return') {
						highlightedDates = _self.availableDatesForTravelPassReturn;
					}
				}
				if ($.inArray(formattedDate, highlightedDates) !== -1) {
					const [flag, className, title] = highlightMobileDays(date);
					const highlighted = 'highlighted ' + className;
					return [true, highlighted, "Available"];
				} else {
					let highlighteddays = highlightMobileDays(date);
					return [].concat(highlighteddays);
				}
			} else {
				return highlightMobileDays(date);
			}
		}

		$(function() {
			let $dateFormat: any = 'd M yy',
			$departDate = curInstance.find('.departureDateMobile')
			.datepicker({
				showButtonPanel: true,
				closeText: $('#ibe-standalone-iframe').length > 0 ? '' : '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: today,
				beforeShowDay: (date) => highlightForDateAvailablity(date, 'dept'),
				dateFormat: 'd M yy',
				maxDate: maxLimitDate,
				numberOfMonths: 2,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					let $lowfareFrom:any = _self.$instance.find('.ibe-mob-from--location').val();
					let $lowfareTo:any = _self.$instance.find('.ibe-mob-to--location').val();
					let $lowfareDate:any = $('.departureDateMobile').val();
					var dateObj = new Date($lowfareDate);
					var momentObj = moment(dateObj);
					var momentString = momentObj.format('DDMMYY');

					setTimeout(function () {
						_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
						}, 500);
				},
				afterShow: function() {
					bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				},
				onChangeMonthYear: function(month:any, year:any, dp:any) {
					_self.bcommon.lawfareAPI();
				}
			})

			.on('change', function() {
				$returnDate.datepicker('option', 'minDate', getDate(this));
				let $nextReturnDateMobile:any = $(this).next('.returnDateMobile');
				if ($nextReturnDateMobile.val() === ""){
				window.setTimeout($.proxy(function() {
					$nextReturnDateMobile.focus();
				}, this), 100);
			}	else{
			
			}
				if(curInstance.find('.sidetrippanel').is(":visible")) {
					curInstance.find('.sidetrippanel').hide();					
					curInstance.find('.mobile-search-form-submit').show();
				}
			}),

			$returnDate = curInstance.find('.returnDateMobile').datepicker({
				showButtonPanel: true,
				closeText: $('#ibe-standalone-iframe').length > 0 ? '' :'<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 'd M yy',
				minDate: today,
				maxDate: maxLimitDate,
				beforeShowDay: (date) => highlightForDateAvailablity(date, 'return'),
				numberOfMonths: 2,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					let $lowfareFrom:any = _self.$instance.find('.ibe-mob-from--location').val();
					let $lowfareTo:any = _self.$instance.find('.ibe-mob-to--location').val();
					let $lowfareDate:any = $('.departureDateMobile').val();
					var dateObj = new Date($lowfareDate);
					var momentObj = moment(dateObj);
					var momentString = momentObj.format('DDMMYY');

					setTimeout(function () {
						_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
						}, 500);
				},
				afterShow: function() {
					bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				},
				onChangeMonthYear: function(month:any, year:any, dp:any) {
					_self.bcommon.lawfareAPI();
				}
			})

			.on('change', function() {
			//	$departDate.datepicker('option', 'maxDate', getDate(this));
			if(curInstance.find('.sidetrippanel').is(":visible")) {
				curInstance.find('.sidetrippanel').hide();					
				curInstance.find('.mobile-search-form-submit').show();
			}
			});
			//updateDatePickerCells();
			function updateDatePickerCells() {
				let getlowfareurl: string = '';
				if (window.location.hostname === 'localhost' && window.location.port == "5000") {
					getlowfareurl = '/dummy-data/lowFare.json';
				}
				$.ajax({
					type: 'GET',
					url: getlowfareurl,
					success: function (data: any) {					
						let json: any = null;
						if (typeof data === 'string') {
							json = JSON.parse(data);
						} else {
							json = data;
						}
	
						/* Wait until current callstack is finished so the datepicker
						   is fully rendered before attempting to modify contents */
						setTimeout(function () {
							//Fill this with the data you want to insert (I use and AJAX request).  Key is day of month
							//NOTE* watch out for CSS special characters in the value						
							var cellContents = { 1: '$20.00', 2: '4', 15: '60', 28: '99', 31: '3' };
	
							//Select disabled days (span) for proper indexing but // apply the rule only to enabled days(a)
							$('.ui-datepicker td > *').each(function (idx: any, elem: any) {
								var value = json[idx].totalFareAmount || 0;
								var index = json[idx].refNo;
	
								// dynamically create a css rule to add the contents //with the :after                         
								//             selector so we don't break the datepicker //functionality 
								var className = 'datepicker-content-' + index.toString();
	
								if (value == 0)
									addCSSRule('.ui-datepicker td a.' + className + ':after {content: "\\a0";}'); //&nbsp;
								else
									addCSSRule('.ui-datepicker td a.' + className + ':after {content: "$' + value + '";}');
	
								$(this).addClass(className);
								$(this).addClass('calender-lowfare-padding');
								
							});
						}, 0);
					},
					error: function (error: any) {
						console.log("Error while getting low fare info", error);
					}
				});
			}
			var dynamicCSSRules: any = [];
			function addCSSRule(rule: any) {
				if ($.inArray(rule, dynamicCSSRules) == -1) {
					$('head').append('<style>' + rule + '</style>');
					dynamicCSSRules.push(rule);
				}
			}
			function getDate($element: any) {
				let $getDate: any;
				try {
					$getDate = $.datepicker.parseDate($dateFormat, $element.value);
				} catch(error) {
					$getDate = null;
				}
				return $getDate;
			}
		});
		// This code commentted because its not working as expected and issue #6299 
		// $('#ui-datepicker-div').on('mouseover','td',function() {
		// 	if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected') && !curInstance.find('.container--side-trip').is(":visible")){
		// 		if (curInstance.find('.departureDateMobile').val()){
		// 			$(this).parent().addClass("finalRow");
		// 			//ugly traversing
		// 			var parent = $(this).parent(); //tr
		// 			var parentParent = $(parent).parent(); //tbody
		// 			var parentParentParent = $(parentParent).parent(); //table
		// 			var parentParentParentParent = $(parentParentParent).parent(); //div

		// 			curInstance.find('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
		// 			$(this).prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

		// 			//check if selecting on last cal
		// 			if ($(parentParentParentParent).hasClass("ui-datepicker-group-last")) {
		// 				curInstance.find('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
		// 			}
		// 		}
		// 	}
		// });

		curInstance.find('.departureDateMobile.oneway-trip').datepicker({
			showButtonPanel: true,
			closeText: $('#ibe-standalone-iframe').length > 0 ? '' :'<i class="fa fa-times" aria-hidden="true"></i>',
			minDate: today,
			dateFormat: 'd M yy',
			beforeShowDay: (date) => highlightForDateAvailablity(date, 'dept'),
			maxDate: maxLimitDate,
			numberOfMonths: 2,
			firstDay: 1,
			beforeShow: function(ele:any, obj:any) {
				if($('.ibe-refresh').length >0) {
					$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
				}
				$curDatepickerInst = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
				let $lowfareFrom:any = _self.$instance.find('.ibe-mob-from--location').val();
				let $lowfareTo:any = _self.$instance.find('.ibe-mob-to--location').val();
				let $lowfareDate:any = $('.departureDateMobile').val();
				var dateObj = new Date($lowfareDate);
				var momentObj = moment(dateObj);
				var momentString = momentObj.format('DDMMYY');

				setTimeout(function () {
					_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
					}, 500);
			},
			afterShow: function() {
				bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			},
			onChangeMonthYear: function(month:any, year:any, dp:any) {
				_self.bcommon.lawfareAPI();
			}
		});

		// Multi city trip calendar
		if (window.location.search.indexOf('multicity=true') > -1) {
			$tripTypeContainer.find('.returnTrip').removeClass('selected');
			$tripTypeContainer.find('.multiCityTrip').addClass('selected');
			_self.$instance.find('.single-cityTrip--Container').hide();
			_self.$instance.find('.multi-cityTrip--Container').show();
		}

		let $multiCityDateFormat:any = 'd M yy';

		let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');

		// initialize datepicker for each multicity date item
		$multiCityDestGroup.each(function(index:number, el:any) {
			let $dateInput = $(this).find('.dateDeparture');
			let $nextdateInput:any;

			if (index < $multiCityDestGroup.length) {
				$nextdateInput = $($multiCityDestGroup[index+1]).find('.dateDeparture');
			}

			$dateInput.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: nowDate,
				dateFormat: 'd M yy',
				maxDate: maxLimitDate,
				numberOfMonths: 2,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					if (!curInstance.find('.multicityTrip').length) {
						curInstance.find('#ui-datepicker-div').addClass("multicityTrip");
					}
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					let $lowfareFrom:any = _self.$instance.find('.ibe-mob-from--location').val();
					let $lowfareTo:any = _self.$instance.find('.ibe-mob-to--location').val();
					let $lowfareDate:any = $('.departureDateMobile').val();
					var dateObj = new Date($lowfareDate);
					var momentObj = moment(dateObj);
					var momentString = momentObj.format('DDMMYY');

					setTimeout(function () {
						_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
						}, 500);
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				},
				onChangeMonthYear: function(month:any, year:any, dp:any) {
					_self.bcommon.lawfareAPI();
				}
			}).on('change', (e:any) => {
				if ($nextdateInput.length) {
					//$nextdateInput.datepicker('option', 'minDate', getMultiCityDate(e.target));
				}
			});
		});

		/**
		 * Parse multicity datepicker value from target element
		 */
		let getMultiCityDate:any = ($element: any) => {
			let $getMultiDate: any;
			try {
				// console.log($multiCityDateFormat, $element, $element.value);
				$getMultiDate = $.datepicker.parseDate($multiCityDateFormat, $element.value);
			} catch(error) {
				//console.error(error);
				$getMultiDate = null;
			}
			// console.log($getMultiDate);
			return $getMultiDate;
		}
	}

	/**
	 * @function passengerDetails
	 * !!! Properly scoped
	 */
	passengerDetails(): void {
		let _self = this;
		let $ticketAdultInput:number   = 1;
		//let $ticketYouthInput:number = 0;
		let $ticketChildInput:number   = 0;
		let $ticketInfantInput:number  = 0;
		let $totalTickets:number       = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$instance.find('.total-passengers');
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)'); // for mh sports only

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking     = curInstance.find('.group-booking');

		$totalPassenger.find('.total-nos').html($totalTickets);
		_self.$instance.find('input.total-tickets--value').val($totalTickets);

		_self.$instance.find('.mobile-ticketnos--btn').on('click', function(e:any){
			e.preventDefault();
			let $passengerDetailsActive:any = curInstance.find('[data-mob-booking-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-mob-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-mob-infant--input');
			let $childInput = $passengerDetailsActive.find('.ticket-mob-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-mob-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error---mobile');
			let $infantBookingErr = curInstance.find('.infant-booking--error---mobile');


			// get currently acted on input field
			var fieldName   = $(this).attr('data-field'),
			type        = $(this).attr('data-type'),
			input       = curInstance.find("input[name='"+fieldName+"']"),
			currentVal   = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
				if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
					}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersInfant"){
								if(currentVal-1>=$('#mobile-bookflight--container .ticket-mob-adult--input').val())
								$('#mobile-bookflight--container .infant-nos .mobile-ticketnos--btn.plus').attr('disabled', true);
							}
				} else if (type == 'plus') {
					if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
					}
					if (parseInt(input.val()) == input.attr('max')) {
						$(this).attr('disabled', true);
					}
					if(fieldName== "passengersInfant"){
								
						if(currentVal+1 >= $('#mobile-bookflight--container .ticket-mob-adult--input').val()){
							// $('#book-flight--container .passengersAdult').val(currentVal + 1);
							$('#mobile-bookflight--container .infant-nos .mobile-ticketnos--btn.plus').attr('disabled', true);
						}
					}
				}
			} else {
				input.val(0);
			}

			// check if infants added exceeds adults added and display error if met
			let $adultInputVal:number  = parseInt($adultInput.val());
			let $infantInputVal:number = parseInt($infantInput.val());

			// test if infants added > adults added
			// display error message if true
			// only show error below infant item
			if ($infantInputVal == $adultInputVal){
				$infantBookingErr.hide();
				curInstance.find('.infant-nos .input-group--btn .mobile-ticketnos--btn.plus').attr('disabled', true);
			}
			else if ($infantInputVal > $adultInputVal) {
				$infantBookingErr.show();
				curInstance.find('.infant-nos .input-group--btn .mobile-ticketnos--btn.plus').attr('disabled', true);
				// $adultBookingErr.show();
			} else {
				$infantBookingErr.hide();
				curInstance.find('.infant-nos .input-group--btn .mobile-ticketnos--btn.plus').attr('disabled', false);
				// $adultBookingErr.hide();
			}

		});

		// disable user input on field (next statement will no longer have any effect)
			curInstance.find('.minus-plus-input').attr('readonly', true);
		// store current value of input to data-attribute on focus
		// in case user manually edits fields
			_self.$instance.find('.minus-plus-input').focusin(function(){
				$(this).data('oldValue', $(this).val());
			});

		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.minus-plus-input').on('change', function() {
			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
				if (valueCurrent >= minValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
				if (valueCurrent <= maxValue) {
					curInstance.find(".mobile-ticketnos--btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
				} else {
				$(this).data('oldValue',$(this).val());
				}
			updateTicketQtys();
			});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
			_self.$instance.find('.minus-plus-input').keydown(function (e:any) {
				if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
					(e.keyCode == 65 && e.ctrlKey === true) ||
					(e.keyCode >= 35 && e.keyCode <= 39)) {
					return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});
		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-mob-booking-passenger-details-selected]');
			$ticketTeenagerInput = parseInt($passengerDetailsActive.find('.ticket-mob-teenager--input').val());
			// get current values in input field and assign to method vars
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-mob-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-mob-child--input').val());
			$ticketInfantInput = parseInt($passengerDetailsActive.find('.ticket-mob-infant--input').val());

			// only adult and child tickets count towards limit
			if (athleteId != null) {
				$totalTickets = $ticketAdultInput;
			} else {
				$totalTickets = $ticketAdultInput + $ticketTeenagerInput + $ticketChildInput;
			}
			let $totalPassengersVal:any = $totalTickets + $ticketInfantInput;
			let $totalPassenger:any 	  = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('.total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			let $isEnableNinePass: any	=	$('#isEnableNinePass');
			//10930 - PROD > MH.com > More than 9 passengers link is not appearing for other site edition
			// if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9) && (window.location.href.indexOf('/my/') > 0)) {
			if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9)) {
			
				$groupBooking.show();
			} else {
				$groupBooking.hide();
			}
			if ($totalTickets >= 2) {
				$totalPassenger.find('.type').html('Passengers');
			} else {
				$totalPassenger.find('.type').html('Passenger');
			}

			if ($totalTickets >= 9) {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				 curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', false);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', false);
			}
			if (($('#members-travel--subsidy').length) > 0) {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .minus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .minus').attr('disabled', true);
				curInstance.find('.teenager-nos .input-group--btn .minus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .minus').attr('disabled', true);
				// curInstance.find('.booking-person.infant-cat').addClass('hide');
				curInstance.find('.booking-person.group-booking').addClass('hide');
			}
		}
	}

	/**
	 * @function merciSubmitFormHandler
	 * !!! Properly scoped
	 */
	merciSubmitFormHandler(): void {
		let _self = this;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let initMerciFormSubmit:any = function() {
	    let $screenSize:any = $(window).width();
	    if ($screenSize < 768) {
	      // console.log("Mobile screen");
			let del=_self.getOfficeCode();

			_self.$instance.find('.mobile-search-form-submit').off('click.submit-mobile-booking').on('click.submit-mobile-booking', (evt: any) => {
				evt.preventDefault();
				_self.bookingFormSubmit.mobileBookingFormValidation(curInstance, _self.$officeCode, function ($officeCode: any) {
					//let isSideTripEnabled =  $('#isSideTripEnable').val();
					//if (isSideTripEnabled === 'Yes') {
					// 	if (_self.bookingFormSubmit.mobileSidetripEligibilityCheck(curInstance)) {
					// 		curInstance.find('.sidetrippanel').show();
					// 		curInstance.find('.mobile-search-form-submit').hide();
					// 	} else {
					// 		curInstance.find('.sidetrippanel').hide();
					// 		curInstance.find('.mobile-search-form-submit').show();
					// 		let $fromOrigin = curInstance.find('.ibe-mob-from--location').val();
					// 		_self.bookingFormSubmit.dxBookingFormSubmit(curInstance, '', '', '', $officeCode);
					// 	}
					// } else {
						curInstance.find('.sidetrippanel').hide();
						curInstance.find('.mobile-search-form-submit').show();
						let $fromOrigin = curInstance.find('.ibe-mob-from--location').val();
						_self.bookingFormSubmit.dxBookingFormSubmit(curInstance, '', '', '', $officeCode);
					//}
				});
			});
			_self.$instance.find('.mobile-search-nofst-form-submit').off('click.submit-mobile-booking').on('click.submit-mobile-booking', (evt: any) => {
				evt.preventDefault();
				_self.bookingFormSubmit.mobileBookingFormValidation(curInstance, _self.$officeCode, function ($officeCode: any) {
					let $fromOrigin = curInstance.find('.ibe-mob-from--location').val();
					_self.bookingFormSubmit.dxBookingFormSubmit(curInstance, '', '', '', $officeCode);
				});
			});
	    } else { //if(widowWidth <= 767)
	      // console.log("Desktop screen");
	    }
		};

		$(window).resize(initMerciFormSubmit);
		initMerciFormSubmit();
	}

	/**
	 * @function getOfficeCode
	 * !!! Properly scoped
	 */
	getOfficeCode(): void {
		let _self = this;

		let setOfficeID = function ($fromOfficeID:any) {
			_self.$officeCode = $fromOfficeID;
		};

		_self.$instance.find('.ibe-mob-from--location').change(function (e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_val = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID: any;
			if ($selected_text.includes('|')) {
				if ($selected_text.split('|')[0] === 'Recent') {
					$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
				} else {
					$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
				}
			} else {
				$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
			}
			setOfficeID($fromOfficeID);
		});

		_self.$instance.find('[name="mobMultiCityfromLocation1"]').off('change.officecode').on('change.officecode', function(e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_value = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID: any;
			if ($selected_text.includes('|')) {
				if ($selected_text.split('|')[0] === 'Recent') {
					$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
				} else {
					$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
				}
			} else {
				$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
			}
			setOfficeID($fromOfficeID);
		});
	}

	/**
	 * Init add remove buttons for multicity ibe form
	 * @return {any} [description]
	 * !!! Global
	 */
	initMultiCityAddRemoveBtns():void {
		let _self = this;

		let addFlightBtn:any = _self.$instance.find('.mobile-multi-cityTrip--Container .mobAddAnotherFlight');
		let removeBtn:any = _self.$instance.find('.mobile-multi-cityTrip--Container .multi-city--destination-group .mob-remove-flight a');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		// debug only
		var multicitylink = _self.$instance.find('a[data-omni="ibe_mob_bookflight_multicity"]');
		// debug only

		// display new flight items
		addFlightBtn.on('click', function(e:any) {
			e.preventDefault();
			let hiddenDests:any = curInstance.find('.mobile-multi-cityTrip--Container .multi-city--destination-group.multi-city--hide');
			if (hiddenDests.length) {
				let firstDestHidden:any = hiddenDests[0];
				// show first instance of hidden destination field.
				// if all fields are shown, fade out and "disable the button"
				$(firstDestHidden).removeClass('multi-city--hide');
				firstDestHidden.dataset.flightEnabled = 1;
				let remainingFlightsAllowed:number = hiddenDests.length - 1;
				if (!remainingFlightsAllowed) {
					$(this).css({
						'opacity': 0.35,
						'cursor': 'not-allowed'
					});
				}
			}

			let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');
			let j:number = 1;

			$multiCityDestGroup.each(function (i: number) {				
				let $mcityFlightCount: any = $(this).find('.flightcount');				
				if(!$(this).hasClass('multi-city--hide')) {
					$mcityFlightCount[0].innerHTML = $mcityFlightCount[0].children[0].outerHTML + $mcityFlightCount.text().trim().split(' ')[0] +' '+ j++;
				}
			});
			return;
		});

		// hide flight item
		removeBtn.on('click', function(e:any) {
			e.preventDefault();
			let destToHide:any = $(this).parents().eq(1);
			destToHide.addClass('multi-city--hide');
			destToHide[0].dataset.flightEnabled = 0;

			// get id value from flight fieldset
			let destId = destToHide[0].dataset.flightNo;
			destId--;

			let $errorValidation:any = curInstance.find('.error-validation'),
				errObj:any = {
						errFromLi   : $errorValidation.find('span[data-error="emptyFlightFrom'+destId+'"]'),
						errToLi     : $errorValidation.find('span[data-error="emptyFlightTo'+destId+'"]'),
						errDepLi    : $errorValidation.find('span[data-error="duplicateFlightDestinations'+destId+'"]'),
						errDupLi    : $errorValidation.find('span[data-error="emptyDepartureDate'+destId+'"]'),
						errPrevFlLi : $errorValidation.find('span[data-error="prevFlightMoreCurrFlight'+destId+'"]')
				};

			// remove error messages if exist for each error item
			$.each(errObj, function(key:string, value:any){
				$(this).fadeOut(300, function(){
					$(this).remove();
				});
			});

			let hiddenDests:any = curInstance.find('.mobile-multi-cityTrip--Container .multi-city--destination-group.multi-city--hide');

			// if able to add flights, re-enable the "add flights" button
			let remainingFlightsAllowed:number = hiddenDests.length;
			if (remainingFlightsAllowed) {
				addFlightBtn.css({
					'opacity': '',
					'cursor': ''
				});
			}

			let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');
			let j:number = 1;

			$multiCityDestGroup.each(function (i: number) {				
				let $mcityFlightCount: any = $(this).find('.flightcount');				
				if(!$(this).hasClass('multi-city--hide')) {
					$mcityFlightCount[0].innerHTML = $mcityFlightCount[0].children[0].outerHTML + $mcityFlightCount.text().trim().split(' ')[0] +' '+ j++;
				}
			});
		});
	}

		/**
	 * @function ibeMultiFormSubmitHandler
	 * !!! Properly scoped
	 */
	ibeMultiFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.error-validation').first();
		let $singleTripSubmitBtn:any    = _self.$instance.find('.single-city--bookflight');
		let $multiTripSubmitBtn:any     = _self.$instance.find('.mobile-multi-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.getOfficeCode();

			$multiTripSubmitBtn.on('click', (e:any) => {
				this.$error = [];
				e.stopPropagation();
				e.preventDefault();
				$errorValidation.show();

				_self.bookingFormSubmit.mobileMultiBookingFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
					let formObj:any = _self.multiBookingFormObject(curInstance);

					_self.bookingFormSubmit.mobileMultiBookingFormSubmit(curInstance, formObj, $officeCode);
				});
			});
		//}
	}

	/**
	 * @function multiBookingFormObject
	 * parse data object from multi booking form ond fields
	 * @return {any} - form object
	 * !!! Properly scoped
	 */
	multiBookingFormObject($instance:any): any {
		let _self = this;
		// clean data (remove unchecked but filled in flight details)
		// use data attributes for form validation instead (in case classes gets overwritten in the future)
		var destinationFields = $instance.find('.mobile-multi-cityTrip--Container fieldset[data-type="destination-input"]');

		destinationFields.each(function(){
			// if flight details have been filled in but the flight row has been removed
			// (clicked the cross button), empty the input fields before serializing form
			// inputs.
			if (!parseInt(this.dataset.flightEnabled)) {
				var destFields = $(this).find('select');
				$(destFields).each(function(){
					this.selectedIndex = -1;
				});

				var depDateInput = $(this).find('input.dateDeparture');
				depDateInput[0].value = "";
			}
		});

		// parse form data
		let formData:any = $instance.find('[data-mob-multi-booking--trip]').serializeArray();
		let formObj:any = {};

		$(formData).each(function(i:any, field:any){
			formObj[field.name] = field.value;
		});

		// clean and re-order input vars for flight destinations
		formObj = _self.multiCleanDestData(formObj);

		// get office code from beginning destination value
		_self.getOfficeCode();

		return formObj;
	}

	/**
	 * [multiCleanDestData description]
	 * Re-arrange and shift up the destination params to ensure they are listed as how
	 * the user wants them to ensure no empty fields between filled destinations.
	 *
	 * ie. user fills in row 1 - row 4 and deletes row 3 before submission.
	 * final serialized form contains:
	 * row 1: data
	 * row 2: data
	 * row 3: empty
	 * row 4: data
	 *
	 * re-arrange dataset so data is pushed upwards:
	 *
	 * row 1: data
	 * row 2: data
	 * row 3: data
	 * row 4: empty
	 * @param  {[type]} formObj [description]
	 * @return {[obj]} cleanedFormOPb [description]
	 * !!! Properly scoped
	 */

	multiCleanDestData(formObj:any):any {
		let i:number = 1;
		let tempId:number = 1;
		let cleanedDestObj:any = {};

		// loop through all destination input data
		// if data is valid, add to temp object (with its own id range),
		// else disregard
		// increment temp object id only if data is valid and added
		while (i < 7) {
			// if form row data exists
			if (formObj["mobMultiCityfromLocation"+ i] && formObj["mobMultiCityfromLocation"+ i] && formObj["mobMultiCityDepartureDate"+ i]) {
				// clone row data into temp object
				cleanedDestObj["B_LOCATION_"+ tempId] = formObj["mobMultiCityfromLocation"+ i];
				cleanedDestObj["E_LOCATION_"+ tempId] = formObj["mobMultiCitytoLocation"+ i];
				cleanedDestObj["B_DATE_"+ tempId]     = formObj["mobMultiCityDepartureDate"+ i];

				tempId++;
			}

			// reset row data in form object (irregardless filled or not)
			formObj["B_LOCATION_"+ i] = undefined;
			formObj["E_LOCATION_"+ i] = undefined;
			formObj["B_DATE_"+ i]     = "";

			i++;
		}

		// replace form data with new cleaned data values
		let destVars:any = Object.keys(cleanedDestObj);

		destVars.forEach(function(destVar:any) {
			formObj[destVar] = cleanedDestObj[destVar];
		});

		return formObj;
	}

	/**
	 * determine via parent container data-attribute if form is cug.
	 * if cug, hide payment and redemption login sections
	 */
	cugForm(): void {
		let _self = this;

		let cugCondition = _self.$instance.attr('data-cug') === 'true';

		if (cugCondition) {
			//_self.$instance.addClass('cug');
			_self.$instance.find('.payment-type-container').hide().addClass('hidden');
			_self.$instance.find('.container--redemption-login').hide().addClass('hidden');
			//_self.$instance.find('.couponCode').hide();
		} else {
			// remove cug hidden input
			_self.$instance.find('input[name="param_cug"]').remove();
		}
	}
		/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * only for MOBILE ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * 2018/03/20 update:
	 * - extend method to accept params (data,instance) to manually invoke and
	 *   populate topnav ibe for deep link
	 */
	populateOnload(data?:ibeTripData, instance?:any): void {
		let _self = this;
		let tripData:ibeTripData = {};

		// use current instance and dataset of instance if not passed into method
		if (instance === undefined) {
			instance = _self.$instance;
		}

		if (data === undefined) {
			tripData = _self.$instance.data();

			// cast date params as string
			if (tripData.fromDate) {
				tripData.fromDate = tripData.fromDate.toString();
			}
			if (tripData.toDate) {
				tripData.toDate = tripData.toDate.toString();
			}
		} else {
			tripData = data;
		}

		// trip type (set first as current behavior wipes input fields after change)
		// use promise to determine completion before setting other fields
		// no namespace on click for mobile
		let tripTypeSet = $.Deferred();

		switch (tripData.triptype) {
			case 'R':
			case 'return':
				instance.find('.trip-type--container .returnTrip').trigger('click', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'O':
			case 'oneway':
				instance.find('.trip-type--container .oneWayTrip').trigger('click', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'M':
			case 'multicity': // no multicity for mobile
			default:
				tripTypeSet.resolve('R'); // retain default (return) and resolve promise
				break;
		}

		tripTypeSet.promise();

		$.when(tripTypeSet).done((triptype:string) => {
			// payment type (set before OnD)
			// if multicity flow is set, don't change payment type to miles
			let $paymentTypeInput = instance.find('.payment-method-options');
			switch (tripData.paymentType) {
				case 'C':
				case 'cash':
					$paymentTypeInput.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true).click();
					break;
				case 'M':
				case 'miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).click();
					}
					break;
				case 'CM':
				case 'cash_miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', true).click();
					}
					break;
				default:
					break;
			}

			// ond fields
			switch (triptype) {
				case 'R':
				case 'return':
				case 'O':
				case 'oneway':
					// assign "to location" value to prepop into class variable
					// (to await completion of updating "from location")
					// following which the "to location" value will be populated
					if (tripData.toLoc !== undefined) {
						_self.toPrepop = tripData.toLoc;
					}

					// from location (selectize instance)
					if (tripData.fromLoc !== undefined) {
						let $fromLocationInput = instance.find('select.ibe-mob-from--location')[0].selectize;
						let $fromLocationMobileInput:any = instance.find('.ibe-mob-from--location-input');
						$fromLocationInput.setValue(tripData.fromLoc);
						let $fromLocationMobTitle: any = $fromLocationMobileInput.parent().find('.booking-form--title');
						$fromLocationMobTitle.addClass('input-filled');
						$fromLocationMobileInput.html('<div>' +
								($fromLocationInput.$input.text() ? '<span class = "airportname airportselected">' + $fromLocationInput.$input.text().trim().split('|')[0] + ' (' + $fromLocationInput.$input.text().trim().split('|')[2] + ')</span>': '') +
								'</div>');
					}
					break;
				case 'M':
				case 'multicity': // no multicity for mobile
				default:
					break;
			}

			// passengers input
			// populate values into input fields and trigger change to update displayed total value
			// adult
			if (tripData.psgAdult !== undefined) {
				let $psgAdultInput = instance.find('.minus-plus-input[name="passengersAdult"]');
				$psgAdultInput.val(parseInt(tripData.psgAdult)).trigger('change');
			}

			// child
			if (tripData.psgChild !== undefined) {
				let $psgChildInput = instance.find('.minus-plus-input[name="passengersChildren"]');
				$psgChildInput.val(parseInt(tripData.psgChild)).trigger('change');
			}

			// infant
			if (tripData.psgInfant !== undefined) {
				let $psgInfantInput = instance.find('.minus-plus-input[name="passengersInfant"]');
				$psgInfantInput.val(parseInt(tripData.psgInfant)).trigger('change');
			}

			/**
			 * test validity of date value for single trip
			 * criteria:
			 * - not undefined
			 * - string length > 0
			 * - string does not contain commas (multicity)
			 * @param {string} testString
			 */
			let validSingleDate = function (testString:string) {
				return (testString !== undefined && testString.length > 0 && testString.indexOf(',') < 0);
			};

			// travel dates (set last, should only happen after trip type has been set)
			// set date (format using moment and populate val) and trigger blur to set input field focus state
			// if trip type is return/oneway, don't populate datefields if multicity format is detected (comma present)
			switch (triptype) {
				case 'R':
				case 'return':
					// from date
					if (validSingleDate(tripData.fromDate)) {
						let $fromDateInput = instance.find('.returnTrip .departureDateMobile');
						$fromDateInput.val(moment(tripData.fromDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					// to date
					if (validSingleDate(tripData.toDate)) {
						let $toDateInput = instance.find('.returnTrip .returnDateMobile');
						$toDateInput.val(moment(tripData.toDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					break;

				case 'O':
				case 'oneway':
					// oneway from date
					if (validSingleDate(tripData.fromDate)) {
						let $owFromDateInput = instance.find('.oneWayTrip .departureDateMobile');
						$owFromDateInput.val(moment(tripData.fromDate, 'YYYYMMDD').format('DD MMM YYYY')).trigger('blur', 'input');
					}
					break;

				case 'M':
				case 'multicity': // no multicity for mobile
				default:
					break;
			}

			// cabin class
			let $cabinClassInput = instance.find('select.cabin-class-mob')[0].selectize;
  		switch (tripData.cabinType) {
  			case 'F':
  			case 'CFFFIRST':
  				$cabinClassInput.setValue('CFFFIRST');
	  			break;
  			case 'B':
  			case 'CFFBUS':
  				$cabinClassInput.setValue('CFFBUS');
	  			break;
  			case 'E':
  			case 'CFFECO':
  				$cabinClassInput.setValue('CFFECO');
	  			break;
	  		default:
	  			break;
  		}

  		// coupon code
  		let $couponCodeInput = instance.find('[name="couponcode"]');
  		if (tripData.couponCode !== undefined) {
  			$couponCodeInput.val(tripData.couponCode).trigger('blur');
  		}
		});
	}

	/**
	 * fill prepop value to this select if waiting prepop value is present
	 */
	fillToPrepopValue(el:any):void {
		let _self = this;
		let val = _self.toPrepop;

		if (val) {
			el.setValue(val);
			_self.toPrepop = null;
			_self.isIbePrepop = true;
			let $toLocationMobileInput: any = _self.$instance.find('.ibe-mob-to--location-input');
			let $toLocationMobTitle: any = $toLocationMobileInput.parent().find('.booking-form--title');
			$toLocationMobTitle.addClass('input-filled');
			$toLocationMobileInput.html('<div>' +
				(el.$input.text() ? '<span class = "airportname airportselected">' + el.$input.text().trim().split('|')[0] + ' (' + el.$input.text().trim().split('|')[2] + ')</span>' : '') +
				'</div>');	
		}
	}

	/**
	 * parse url params to detect book flight deep link
	 * open and populate with params
	 * ?ibe=bfl&fromLoc=ABC&toLoc=ABC&triptype=ABC&fromDate=ABC&toDate=ABC&paymentType=ABC&cabinType=ABC&psgAdult=ABC&psgChild=ABC&psgInfant=ABC&couponCode=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);

		if (urlParams.ibe && urlParams.ibe === 'bfl') {

			// parse url params into tripdata object
			let tripData:ibeTripData = {};

			tripData.fromLoc = urlParams.fromLoc;
			tripData.toLoc = urlParams.toLoc;
			tripData.triptype = urlParams.tripType;
			tripData.fromDate = urlParams.fromDate ? urlParams.fromDate.toString() : urlParams.fromDate;
			tripData.toDate = urlParams.toDate ? urlParams.toDate.toString() : urlParams.toDate;
			tripData.paymentType = urlParams.paymentType;
			tripData.cabinType = urlParams.cabinType;
			tripData.psgAdult = urlParams.psgAdult;
			tripData.psgChild = urlParams.psgChild;
			tripData.psgInfant = urlParams.psgInfant;
			tripData.couponCode = urlParams.couponCode;

			// pass tripData object and instance into populateData method
			const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');

			// expand mobile ibe
			if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				let $ibeNavList: any = $('#bookingNav li');
	      $ibeNavList.find('.mobile-book-flight').parent().addClass('selected');

	      topNavIbe.show();
				_self.expandIbe(topNavIbe);
			}

			_self.populateOnload(tripData, topNavIbe);
		}
	}

	checkAvailablityEnrichAlways():boolean{
		let _self=this;
		let rtnVal: boolean=_self.isValidFromLocation && _self.isInAllowedListEnrichOnFrom && _self.isValidToLocation;
		if(rtnVal){
			$(".enrichOnDiscountToggleContainer").removeClass('hideclass');
			$(".enrichOnDiscountInformation").addClass('hideclass');
		
		}
		else{
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');
			$(".enrichOnDiscountInformation").addClass('hideclass');
		}
		return rtnVal;
	}

	ONDenrichFromLocation(seletedItem:any){
		let _self=this;
		if (seletedItem) {
			const seletedOptGroup:string = seletedItem.optgroup;
			if(( seletedOptGroup == "With Malaysia Airlines" || seletedOptGroup == "online")){
				const selectedCountry:string = seletedItem.text.split('|')[1];
				if(_self.enrichAlwaysOnCountriesData.includes(selectedCountry)){
					_self.isValidFromLocation=true
					_self.isInAllowedListEnrichOnFrom = true;
					_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
					return;
				}
			}
			else if(seletedOptGroup == "Recent Searches" || seletedOptGroup == "recent-search"){	
				_self.isValidFromLocation=true
				_self.isInAllowedListEnrichOnFrom = true;
				_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
				return;		
			}
		}
		_self.isValidFromLocation=false;
		_self.isInAllowedListEnrichOnFrom=false;
   
		_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
		
	}

	
	ONDenrichToLocation(seletedItem:any):void{
		let _self=this;
		if (seletedItem) {
			const seletedOptGroup:string = seletedItem.optgroup;
			if( seletedOptGroup == "With Malaysia Airlines" || seletedOptGroup == "online") {
				_self.isValidToLocation=true;
				_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
			
				return;
			}
			else if(seletedOptGroup == "Recent Searches"){
	
				const isEnrichAlawaysOn:string = seletedItem.text.split('|')[18];
				if(isEnrichAlawaysOn=='EAON'){
					_self.isValidToLocation=true;
					_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();

					return;
				}
			}
		}
		_self.isValidToLocation=false;
		_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();


	}
}

let scope:Element = document.querySelector('[data-mob-ibe--book-flight]');
if (scope){
	try {
		let mobbookflight = new mobileBookingFormContent();
		let bookingformcommon = new bookingFormCommon();
		let bookflightredemption = new bookingFormRedemption();
		let bookflightinfant = new bookingFormInfant();
		let bookingformsideTrip = new bookingFormSideTrip();
		var adobeDataLayer = new adobeDataLayerWrapper();
		// start: init navbar behavior
		mobbookflight.nav();
		mobbookflight.init();
		// end: init navbar behavior

		// mobile ibe
		let mobileIBEs:any = document.querySelectorAll('[data-mob-ibe--book-flight]');
		let numDesktopIBEs:number = mobileIBEs.length - 1;
		let lastOnDDone:any = $.Deferred();
		const topNavIbe = $('.mobile#mab-bookingnav [data-mob-ibe--book-flight]');
		Array.prototype.map.call(mobileIBEs, function(instance:any, i:number) {
			$.when(window['ibeOnDListNew']).done((listData: any) => {
				mobbookflight.setInstance(instance);
				mobbookflight.merciSubmitFormHandler();
				mobbookflight.getOfficeCode();
				mobbookflight.ibeTripType();
				mobbookflight.calendarComponent();
				mobbookflight.passengerDetails();
				mobbookflight.passengerType();
				mobbookflight.initMultiCityAddRemoveBtns();
				mobbookflight.ibeMultiFormSubmitHandler();
				mobbookflight.recentSearch();
				bookingformsideTrip.init(instance);
				bookingformsideTrip.ibeTripType(instance);
				bookingformsideTrip.calendarComponentSideTrip(instance);
				bookingformsideTrip.calendarComponent(instance);				
				bookingformsideTrip.passengerTypeSideTrip(instance);
				bookingformsideTrip.passengerDetailsSideTrip(instance);				
				// bookingformsideTrip.passengerTypeOneWay(instance);
				// bookingformsideTrip.passengerDetailsOneWay(instance);
				// bookingformsideTrip.passengerDetailsReturn(instance);
				// bookingformsideTrip.passengerTypeReturn(instance);
				console.log('%cc005mobbook%c ond done', 'background-color: yellow', 'background-color: initial');
				// onload use revenue OnD
				let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
				let studentDashboard = document.querySelector('.student-dashboard');
				let listItems:string;
				if (studentEnrichIdCookieVal != null && studentDashboard != null) {				
						listItems = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'From');
				} else {					
						listItems = bookingformcommon.parseOnDListItemsNew(listData, 'revenue', 'From');					
				}

				let listToItems: string;
				if (studentEnrichIdCookieVal != null && studentDashboard != null) {
					listToItems = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'To');
				} else {
					listToItems = bookingformcommon.parseOnDListItemsNew(listData, 'revenue', 'To');
				}
				
				mobbookflight.initSelectize(listItems, listToItems);
				let listItemsSideTrip: string;
				listItemsSideTrip = bookingformcommon.parseOnDListItemsNew(listData, 'sidetrip', 'From');
				bookingformsideTrip.initSelectize(listItemsSideTrip, instance);
				bookingformsideTrip.initSelectizeIbeSideTrip(listItemsSideTrip, instance);
				bookingformsideTrip.sidetripLocationSubmit(instance);
				bookingformsideTrip.optforsidetripoffer(instance, mobbookflight.getOfficeCode());
				bookflightinfant.toggleSubmitBtnDisplay(instance);

				bookflightredemption.initPaymentMethods($(instance));
				bookflightredemption.initRdmLogin($(instance), '.mobile-search-form-submit', '.mobile-search-form-multi-submit', '.ibe-mob-from--location', '.ibe-mob-to--location');
				mobbookflight.cugForm();
			

				mobbookflight.populateOnload();
				if (numDesktopIBEs == i) {
					lastOnDDone.resolve();
				}
			});
		});

		lastOnDDone.promise();

		$.when(lastOnDDone).done(() => {
			mobbookflight.deeplink();
		});
		let _self = this;
		let urlParams = bookingformcommon.getUrlVars(window.location.href);
		let $ibeNavList: any = $('#bookingNav li');

		if ($('body').hasClass('home')) {
				if (urlParams.ibe && urlParams.ibe !== 'bfl' ) {
					
				} else {
			  topNavIbe.show();
			  $ibeNavList.find('a.mobile-book-flight').parent().addClass('selected');
				}
			}
			if ($('.ibe-refresh').length > 0) {
				mobbookflight.expandIbe(topNavIbe);
			}

	} catch(e) {console.error(e);}
}
